import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Button } from '@/components/ui/button';
import AppButton from '@/components/ui/AppButton';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { Badge } from '@/components/ui/badge';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Textarea } from '@/components/ui/textarea';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@/components/ui/select';
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogTrigger } from '@/components/ui/dialog';
import { useAuth } from '@/contexts/AuthContext';
import { formatCurrency, formatDate, formatDateTime, getMediaUrl } from '@/lib/utils';
import { toast } from '../lib/swal';
import BackupManager from '@/components/admin/BackupManager';
import { 
  Trophy, Users, DollarSign, Layout, Plus, CheckCircle, Clock, 
  Settings, LogOut, Home, Eye, EyeOff, XCircle, Play, Image,
  ChevronRight, ChevronLeft, Calendar, User, Search, Trash2, Edit2, AlertCircle,
  FileText, Banknote, ShieldCheck, RefreshCcw, Mail, Phone,
  TrendingUp, Activity, BarChart4, Save, UserCheck, ShieldClose,
  Key, ShieldOff, Sparkles, MessageCircle, Copy, AlertTriangle, Zap,
  CreditCard, Camera, Loader2, HardDrive, Ticket, X, Shield, MessageSquare
} from 'lucide-react';
import StatCard from '@/components/StatCard';
import TabsNav from '@/components/TabsNav';
import RaffleCard from '@/components/RaffleCard';
import ThemeToggle from '@/components/ThemeToggle';
import CampañasManager from '@/components/admin/CampañasManager';
import MarketingManager from '@/components/admin/MarketingManager';
import websocketService from '../services/websocket';


const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const AdminDashboard = () => {
  // getMediaUrl is now imported from @/lib/utils
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [isRejecting, setIsRejecting] = useState(false);
  const [showResetPasswordModal, setShowResetPasswordModal] = useState(false);
  const [selectedUserReset, setSelectedUserReset] = useState(null);
  const [newPasswordReset, setNewPasswordReset] = useState('');
  const [isResetting, setIsResetting] = useState(false);
  const [passwordReseteada, setPasswordReseteada] = useState(false);
  
  const [sorteos, setSorteos] = useState([]);
  const [usuarios, setUsuarios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showCreateModal, setShowCreateModal] = useState(false);
  const [editingSorteoId, setEditingSorteoId] = useState(null);
  const [boletosPendientes, setBoletosPendientes] = useState([]);
  const [loadingPendientes, setLoadingPendientes] = useState(false);
  const [pendientesPage, setPendientesPage] = useState(1);
  const [pendientesTotalPages, setPendientesTotalPages] = useState(1);
  const [pendientesTotal, setPendientesTotal] = useState(0);
  const [boletosAprobados, setBoletosAprobados] = useState([]);
  const [loadingAprobados, setLoadingAprobados] = useState(false);
  const [sorteoFiltroAprobados, setSorteoFiltroAprobados] = useState('');
  const [numeroBoletoFiltro, setNumeroBoletoFiltro] = useState('');
  const [aprobadosPage, setAprobadosPage] = useState(1);
  const [aprobadosTotalPages, setAprobadosTotalPages] = useState(1);
  const [aprobadosTotal, setAprobadosTotal] = useState(0);
  const [showChangePassword, setShowChangePassword] = useState(false);
  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');
  const [numeroComprobante, setNumeroComprobante] = useState('');
  const [boletoAprobar, setBoletoAprobar] = useState(null);
  const [dialogAprobarOpen, setDialogAprobarOpen] = useState(false);
  // WhatsApp state: datos de la última aprobación/rechazo para construir los mensajes
  const [waPostApproval, setWaPostApproval] = useState(null); // { cliente, sorteo_titulo, numeros_boletos, comprobante, ts }
  const [waPostRejection, setWaPostRejection] = useState(null);
  const [isApproving, setIsApproving] = useState(false);
  const [boletosUsuarioModalOpen, setBoletosUsuarioModalOpen] = useState(false);
  const [boletosUsuarioSeleccionado, setBoletosUsuarioSeleccionado] = useState({ pendientes: [], aprobados: [] });
  const [usuarioSeleccionadoBoletos, setUsuarioSeleccionadoBoletos] = useState(null);
  const [loadingBoletosUsuario, setLoadingBoletosUsuario] = useState(false);
  
  // Estados para diálogos de confirmación (reemplaza window.confirm)
  const [confirmDialog, setConfirmDialog] = useState({ open: false, title: '', message: '', onConfirm: null });
  // Estados para retiros
  const [retiros, setRetiros] = useState([]);
  const [loadingRetiros, setLoadingRetiros] = useState(false);
  const [comprobanteUrl, setComprobanteUrl] = useState('');  const [retiroSeleccionado, setRetiroSeleccionado] = useState(null);
  const [showAprobarRetiro, setShowAprobarRetiro] = useState(false);  const [nuevaLogicaVersion, setNuevaLogicaVersion] = useState(1);
  const [loadingConfig, setLoadingConfig] = useState(false);
  const [sorteoPendienteId, setSorteoPendienteId] = useState(null);
  const [configOperativa, setConfigOperativa] = useState(null); // Sorteo siendo configurado
  const [nuevoTotalBoletos, setNuevoTotalBoletos] = useState(0);
  const [nuevoMinimoBoletos, setNuevoMinimoBoletos] = useState(1);
  const [nuevoPorcentajeManual, setNuevoPorcentajeManual] = useState(100);
  const [sorteoExpandido, setSorteoExpandido] = useState(null);
  const [imagenesTemp, setImagenesTemp] = useState({});
  const [premiosImagenesTemp, setPremiosImagenesTemp] = useState({});
  
  const [isUploadingPremio, setIsUploadingPremio] = useState(false);

  // Estados para paginación de usuarios
  const [usuariosPage, setUsuariosPage] = useState(1);
  const [usuariosTotalPages, setUsuariosTotalPages] = useState(1);
  const [usuariosTotal, setUsuariosTotal] = useState(0);
  const [searchTermUsuarios, setSearchTermUsuarios] = useState('');

  // Branding states
  const [branding, setBranding] = useState({ logo_url: '', app_name: 'WishWay' });
  const [loadingBranding, setLoadingBranding] = useState(false);
  const [uploadingLogo, setUploadingLogo] = useState(false);
  const [selectedLogoFile, setSelectedLogoFile] = useState(null);
  const [logoPreview, setLogoPreview] = useState(null);
  const [showContactoModal, setShowContactoModal] = useState(false);
  const [contactoData, setContactoData] = useState({ tipo_contacto: 'instagram', valor_contacto: 'wishway.oficial' });
  const [isSavingContacto, setIsSavingContacto] = useState(false);

  useEffect(() => {
    if (branding?.tipo_contacto) {
      setContactoData({
        tipo_contacto: branding.tipo_contacto,
        valor_contacto: branding.valor_contacto || ''
      });
    }
  }, [branding?.tipo_contacto, branding?.valor_contacto]);

  const [formData, setFormData] = useState({
    titulo: '', descripcion: '', precio_boleto: '', cantidad_minima_boletos: '',
    cantidad_total_boletos: '', tipo: 'unico', porcentaje_comision: '10',
    color_primario: '#4F46E5', color_secundario: '#06B6D4',
    reglas: '', imagenes: [], etapas: [], premios: []
  });
  
  const [imagenUrl, setImagenUrl] = useState('');
  const [videoUrl, setVideoUrl] = useState('');
  const [globalStats, setGlobalStats] = useState({ visitas_totales: 0, visitas_hoy: 0 });
  const [premioForm, setPremioForm] = useState({
    nombre: '',
    descripcion: '',
    imagen_url: '',
    video_url: ''
  });

  const [etapaForm, setEtapaForm] = useState({ 
    numero: 1, 
    porcentaje: '', 
    premio: '',  // Mantener por compatibilidad
    nombre: '',
    imagen_urls: [],
    video_urls: [],
    premios: []  // NUEVO: Array de premios para múltiples premios por etapa
  });
  const [etapaImagenUrl, setEtapaImagenUrl] = useState('');
  const [etapaVideoUrl, setEtapaVideoUrl] = useState('');

  // Estados para Hero Home
  const [heroConfig, setHeroConfig] = useState({
    titulo: '',
    descripcion: '',
    tipo_fondo: 'image',
    url_fondo: '',
    color_overlay: '#000000',
    opacidad_overlay: 0.4
  });
  const [isSavingHero, setIsSavingHero] = useState(false);

  // Estados para PayPhone
  const [payphoneConfig, setPayphoneConfig] = useState({
    store_id: '',
    token: '',
    porcentaje_adicional: 0,
    activo: false
  });
  const [isSavingPayphone, setIsSavingPayphone] = useState(false);
  const [isLoadingPayphone, setIsLoadingPayphone] = useState(false);

  // Estados para PayPal
  const [paypalConfig, setPaypalConfig] = useState({
    client_id: '',
    client_secret: '',
    modo: 'sandbox',
    porcentaje_adicional: 0,
    activo: false,
    webhook_id: ''
  });
  const [isSavingPaypal, setIsSavingPaypal] = useState(false);
  const [paypalDiagnostics, setPaypalDiagnostics] = useState(null);
  const [isRunningPaypalDiag, setIsRunningPaypalDiag] = useState(false);

  // Estados para diagnóstico PayPhone
  const [payphoneDiagnostics, setPayphoneDiagnostics] = useState(null);
  const [isRunningPayphoneDiag, setIsRunningPayphoneDiag] = useState(false);

  const handleRunPayphoneDiagnostics = async () => {
    setIsRunningPayphoneDiag(true);
    setPayphoneDiagnostics(null);
    try {
      const res = await axios.post(`${API}/admin/payphone-diagnostics`);
      setPayphoneDiagnostics(res.data);
      if (res.data.ok) {
        toast.success('Diagnóstico exitoso: PayPhone funcionando');
      } else {
        toast.error('Diagnóstico encontró problemas - revisa los detalles');
      }
    } catch (error) {
      const msg = error.response?.data?.detail || error.message;
      setPayphoneDiagnostics({ ok: false, error: msg });
      toast.error('Error al ejecutar diagnóstico: ' + msg);
    } finally {
      setIsRunningPayphoneDiag(false);
    }
  };

  const handleRunPaypalDiagnostics = async () => {
    setIsRunningPaypalDiag(true);
    setPaypalDiagnostics(null);
    try {
      const res = await axios.post(`${API}/admin/paypal-diagnostics`);
      setPaypalDiagnostics(res.data);
      if (res.data.ok) {
        toast.success('Diagnóstico exitoso: PayPal funcionando');
      } else {
        toast.error('Diagnóstico encontró problemas - revisa los detalles');
      }
    } catch (error) {
      const msg = error.response?.data?.detail || error.message;
      setPaypalDiagnostics({ ok: false, error: msg });
      toast.error('Error al ejecutar diagnóstico: ' + msg);
    } finally {
      setIsRunningPaypalDiag(false);
    }
  };

  useEffect(() => {
    if (!user || user.role !== 'admin') {
      navigate('/login');
      return;
    }
    fetchData();
    fetchBoletosPendientes(1);
    fetchRetiros();
    fetchHeroConfig();
    fetchPayphoneConfig();
    fetchPaypalConfig();
    fetchBranding();

    // -- REAL-TIME UPDATES --
    // Conectar WebSocket si no está conectado
    websocketService.connect();

    const handleSorteosUpdate = () => {
      console.log('📡 [ADMIN] Lista de sorteos actualizada via socket');
      fetchData();
    };

    websocketService.onSorteosListUpdated(handleSorteosUpdate);

    return () => {
      websocketService.offSorteosListUpdated(handleSorteosUpdate);
    };
  }, [user]);

  // Efecto para inicializar el filtro de boletos aprobados cuando se cargan los sorteos
  useEffect(() => {
    if (sorteos.length > 0 && (!sorteoFiltroAprobados || sorteoFiltroAprobados === 'all')) {
      const firstId = sorteos[0].id;
      setSorteoFiltroAprobados(firstId);
      // No llamar a fetch aquí si el tab no está activo para ahorrar recursos, 
      // pero fetchBoletosAprobados se llama en el useEffect principal si es necesario.
      // En este caso, lo llamaremos para asegurar que al entrar al tab haya datos.
      fetchBoletosAprobados(firstId, numeroBoletoFiltro, 1);
    }
  }, [sorteos]);

  const fetchPayphoneConfig = async () => {
    setIsLoadingPayphone(true);
    try {
      const res = await axios.get(`${API}/admin/payphone-config`);
      setPayphoneConfig(res.data);
    } catch (error) {
      console.error('Error al cargar config payphone:', error);
    } finally {
      setIsLoadingPayphone(false);
    }
  };

  const handleSavePayphone = async () => {
    setIsSavingPayphone(true);
    try {
      await axios.put(`${API}/admin/payphone-config`, payphoneConfig);
      toast.success('Configuración de PayPhone actualizada');
      fetchPayphoneConfig();
    } catch (error) {
      console.error('Error al guardar payphone:', error);
      toast.error('Error al guardar configuración');
    } finally {
      setIsSavingPayphone(false);
    }
  };

  const fetchPaypalConfig = async () => {
    try {
      const res = await axios.get(`${API}/admin/paypal-config`);
      setPaypalConfig(res.data);
    } catch (error) {
      console.error('Error al cargar config PayPal:', error);
    }
  };

  const handleSavePaypal = async () => {
    setIsSavingPaypal(true);
    try {
      await axios.put(`${API}/admin/paypal-config`, paypalConfig);
      toast.success('Configuración de PayPal actualizada');
      fetchPaypalConfig();
    } catch (error) {
      console.error('Error al guardar PayPal:', error);
      toast.error('Error al guardar configuración de PayPal');
    } finally {
      setIsSavingPaypal(false);
    }
  };

  const fetchHeroConfig = async () => {
    try {
      const res = await axios.get(`${API}/admin/hero-home`);
      setHeroConfig(res.data);
    } catch (error) {
      console.error('Error al cargar config hero:', error);
    }
  };

  const handleSaveHero = async () => {
    setIsSavingHero(true);
    try {
      const formData = new FormData();
      formData.append('progreso_falso', heroConfig.progreso_falso || 35.0);

      await axios.post(`${API}/admin/hero-home`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      
      toast.success('Hero Home actualizado correctamente');
      fetchHeroConfig();
    } catch (error) {
      console.error('Error al guardar hero:', error);
      toast.error('Error al guardar configuración');
    } finally {
      setIsSavingHero(false);
    }
  };

  const fetchData = async () => {
    try {
      const [sorteosRes, usuariosRes, statsRes] = await Promise.all([
        axios.get(`${API}/sorteos?incluir_draft=true&incluir_ocultos=true`), // Admin ve todos incluyendo borradores y ocultos
        axios.get(`${API}/admin/usuarios?page=${usuariosPage}&limit=10`),
        axios.get(`${API}/admin/stats-globales`)
      ]);
      setSorteos(sorteosRes.data);
      setUsuarios(usuariosRes.data.usuarios);
      setUsuariosTotalPages(usuariosRes.data.total_pages);
      setUsuariosTotal(usuariosRes.data.total);
      setGlobalStats(statsRes.data);
    } catch (error) {
      console.error('Error al cargar datos:', error);
      toast.error('Error al cargar datos');
    } finally {
      setLoading(false);
    }
  };
  
  const fetchUsuarios = async (page = 1, query = searchTermUsuarios) => {
    setLoading(true);
    try {
      const qParam = query ? `&q=${encodeURIComponent(query)}` : '';
      const response = await axios.get(`${API}/admin/usuarios?page=${page}&limit=10${qParam}`);
      setUsuarios(response.data.usuarios);
      setUsuariosTotalPages(response.data.total_pages);
      setUsuariosTotal(response.data.total);
      setUsuariosPage(page);
    } catch (error) {
      console.error('Error al cargar usuarios:', error);
      toast.error('Error al cargar usuarios');
    } finally {
      setLoading(false);
    }
  };

  const fetchBoletosUsuario = async (userId, userObj = null) => {
    if (userObj) {
      setUsuarioSeleccionadoBoletos(userObj);
    }
    setLoadingBoletosUsuario(true);
    setBoletosUsuarioModalOpen(true);
    try {
      const response = await axios.get(`${API}/admin/boletos-usuario/${userId}`);
      setBoletosUsuarioSeleccionado(response.data);
    } catch (error) {
      console.error('Error al cargar boletos del usuario:', error);
      toast.error('Error al cargar boletos del usuario');
    } finally {
      setLoadingBoletosUsuario(false);
    }
  };

  const handleResetPassword = async () => {
    if (!newPasswordReset || newPasswordReset.length < 6) {
      toast.error('La contraseña debe tener al menos 6 caracteres');
      return;
    }
    
    setIsResetting(true);
    try {
      await axios.put(`${API}/admin/usuario/${selectedUserReset.id}/reset-password`, {
        password: newPasswordReset
      });
      
      toast.success('Contraseña actualizada correctamente');
      setPasswordReseteada(true);
    } catch (error) {
      console.error('Error reseteando contraseña:', error);
      const detail = error.response?.data?.detail;
      toast.error(typeof detail === 'string' ? detail : 'Error al resetear contraseña');
    } finally {
      setIsResetting(false);
    }
  };

  const generarPasswordAutomatico = () => {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let pass = '';
    for (let i = 0; i < 10; i++) {
      pass += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    setNewPasswordReset(pass);
  };

  const enviarWhatsAppPassword = () => {
    if (!selectedUserReset?.celular) {
      toast.error('El usuario no tiene celular registrado');
      return;
    }
    
    // Limpiar el número: quitar cualquier caracter no numérico
    let num = selectedUserReset.celular.replace(/\D/g, '');
    
    // Formateo específico para Ecuador: 
    // Si empieza por 0 (ej: 099...), quitar el 0 y poner 593
    if (num.startsWith('0')) {
      num = '593' + num.substring(1);
    } else if (num.length === 9) {
      // Si tiene 9 dígitos (ej: 99...) y no tiene el 593, agregarlo
      num = '593' + num;
    }
    
    const mensaje = `*WishWay - Soporte*\n\nHola *${selectedUserReset.name}*, tu nueva contraseña de acceso es: \`${newPasswordReset}\`\n\nPor favor, inicia sesión y cámbiala por seguridad.`;
    const url = `https://wa.me/${num}?text=${encodeURIComponent(mensaje)}`;
    window.open(url, '_blank');
  };

  const menuItems = [
    { id: 'dashboard', label: 'Dashboard', icon: Layout },
    { id: 'sorteos', label: 'Sorteos', icon: Trophy },
    { id: 'usuarios', label: 'Usuarios', icon: Users },
    { id: 'pendientes', label: 'Pendientes', icon: Clock },
    { id: 'aprobados', label: 'Aprobados', icon: CheckCircle },
    { id: 'retiros', label: 'Retiros', icon: Banknote },
    { id: 'branding', label: 'Branding', icon: Image },
    { id: 'configuracion', label: 'Mi Perfil', icon: Settings }
  ];

  const fetchBranding = async () => {
    try {
      const response = await axios.get(`${API}/settings/branding`);
      setBranding(response.data);
      setLogoPreview(getMediaUrl(response.data.logo_url));
    } catch (error) {
      console.error('Error al cargar branding:', error);
    }
  };

  const handleLogoFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file.content_type?.startsWith('image/') && !file.type?.startsWith('image/')) {
        toast.error('El archivo debe ser una imagen');
        return;
      }
      setSelectedLogoFile(file);
      setLogoPreview(URL.createObjectURL(file));
    }
  };

  const handleUpdateLogo = async () => {
    if (!selectedLogoFile) {
      toast.error('Selecciona un archivo primero');
      return;
    }

    setUploadingLogo(true);
    const formData = new FormData();
    formData.append('file', selectedLogoFile);

    try {
      const response = await axios.put(`${API}/admin/settings/logo`, formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      });
      toast.success('Logo actualizado correctamente');
      setBranding(prev => ({ ...prev, logo_url: response.data.logo_url }));
      setSelectedLogoFile(null);
      fetchBranding();
    } catch (error) {
      console.error('Error al subir logo:', error);
      toast.error(error.response?.data?.detail || 'Error al actualizar el logo');
    } finally {
      setUploadingLogo(false);
    }
  };

  const handleSaveContacto = async (e) => {
    e.preventDefault();
    setIsSavingContacto(true);
    try {
      await axios.put(`${API}/admin/settings/contacto`, contactoData);
      toast.success('Configuración de contacto actualizada');
      setBranding(prev => ({ ...prev, tipo_contacto: contactoData.tipo_contacto, valor_contacto: contactoData.valor_contacto }));
      setShowContactoModal(false);
    } catch (error) {
      toast.error('Error al guardar configuración de contacto');
    } finally {
      setIsSavingContacto(false);
    }
  };

  const fetchRetiros = async () => {
    setLoadingRetiros(true);
    try {
      const response = await axios.get(`${API}/admin/retiros-pendientes`);
      setRetiros(response.data);
    } catch (error) {
      console.error('Error al cargar retiros:', error);
      toast.error('Error al cargar retiros');
    } finally {
      setLoadingRetiros(false);
    }
  };
  
  const handleAprobarRetiro = async () => {
    if (!comprobanteUrl.trim()) {
      toast.error('Debe ingresar la URL del comprobante');
      return;
    }
    
    try {
      await axios.post(`${API}/admin/retiro/${retiroSeleccionado.id}/aprobar`, {
        comprobante_url: comprobanteUrl
      });
      
      toast.success('Retiro aprobado correctamente');
      setShowAprobarRetiro(false);
      setComprobanteUrl('');
      setRetiroSeleccionado(null);
      fetchRetiros();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al aprobar retiro');
    }
  };
  
  const handleRechazarRetiro = async (retiroId) => {
    const motivo = prompt('Ingrese el motivo del rechazo:');
    if (!motivo) return;
    
    try {
      await axios.post(`${API}/admin/retiro/${retiroId}/rechazar?motivo=${encodeURIComponent(motivo)}`);
      toast.success('Retiro rechazado');
      fetchRetiros();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al rechazar retiro');
    }
  };

  const handleLogout = async () => {
    await logout();
    navigate('/');
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const agregarEtapa = () => {
    // CAMBIO: Validar que tenga al menos 1 premio
    if (!etapaForm.porcentaje || (!etapaForm.premios || etapaForm.premios.length === 0)) {
      toast.error('Completa porcentaje y agrega al menos un premio a la etapa');
      return;
    }
    const nuevaEtapa = {
      numero: formData.etapas.length + 1,
      porcentaje: parseFloat(etapaForm.porcentaje),
      premio: etapaForm.premios[0]?.nombre || '',  // Mantener compatibilidad con campo único
      premios: etapaForm.premios,  // NUEVO: Array de premios
      nombre: etapaForm.nombre || `Etapa ${formData.etapas.length + 1}`,
      imagen_urls: etapaForm.imagen_urls || [],
      video_urls: etapaForm.video_urls || [],
      completado: false
    };
    setFormData(prev => ({ ...prev, etapas: [...prev.etapas, nuevaEtapa] }));
    setEtapaForm({ 
      numero: formData.etapas.length + 2, 
      porcentaje: '', 
      premio: '', 
      nombre: '',
      imagen_urls: [],
      video_urls: [],
      premios: []  // Resetear array de premios
    });
    setEtapaImagenUrl('');
    setEtapaVideoUrl('');
    toast.success('Etapa agregada');
  };

  const eliminarEtapa = (index) => {
    setFormData(prev => ({ ...prev, etapas: prev.etapas.filter((_, i) => i !== index) }));
    toast.success('Etapa eliminada');
  };

  const agregarPremio = () => {
    if (!premioForm.nombre) {
      toast.error('El nombre del premio es obligatorio');
      return;
    }
    const nuevoPremio = { ...premioForm };
    setFormData(prev => ({ ...prev, premios: [...prev.premios, nuevoPremio] }));
    setPremioForm({
      nombre: '',
      descripcion: '',
      imagen_url: '',
      video_url: ''
    });
    toast.success('Premio agregado');
  };

  const handleUploadPremioImage = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    if (!file.type.startsWith('image/')) {
        toast.error('Por favor, selecciona un archivo de imagen');
        return;
    }

    const formData = new FormData();
    formData.append('file', file);

    setIsUploadingPremio(true);
    try {
        const response = await axios.post(`${API}/admin/upload-premio`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        
        setPremioForm(prev => ({ ...prev, imagen_url: response.data.url }));
        toast.success('Imagen subida correctamente');
    } catch (error) {
        console.error('Error al subir imagen:', error);
        toast.error('Error al subir la imagen');
    } finally {
        setIsUploadingPremio(false);
    }
  };

  const eliminarPremio = (index) => {
    setFormData(prev => ({ ...prev, premios: prev.premios.filter((_, i) => i !== index) }));
    toast.success('Premio eliminado');
  };

  const agregarPremioAEtapa = (etapaIndex) => {
    if (!premioForm.nombre) {
      toast.error('El nombre del premio es obligatorio');
      return;
    }
    const nuevoPremio = { ...premioForm };
    setFormData(prev => {
      const etapasActualizadas = [...prev.etapas];
      if (!etapasActualizadas[etapaIndex].premios) {
        etapasActualizadas[etapaIndex].premios = [];
      }
      etapasActualizadas[etapaIndex].premios.push(nuevoPremio);
      return { ...prev, etapas: etapasActualizadas };
    });
    setPremioForm({
      nombre: '',
      descripcion: '',
      imagen_url: '',
      video_url: ''
    });
    toast.success(`Premio agregado a Etapa ${etapaIndex + 1}`);
  };

  const eliminarPremioDeEtapa = (etapaIndex, premioIndex) => {
    setFormData(prev => {
      const etapasActualizadas = [...prev.etapas];
      etapasActualizadas[etapaIndex].premios = etapasActualizadas[etapaIndex].premios.filter((_, i) => i !== premioIndex);
      return { ...prev, etapas: etapasActualizadas };
    });
    toast.success('Premio eliminado de la etapa');
  };

  const handleCrearSorteo = async (e) => {
    e.preventDefault();
    try {
      const sorteoData = {
        ...formData,
        precio_boleto: parseFloat(formData.precio_boleto),
        cantidad_minima_boletos: parseInt(formData.cantidad_minima_boletos),
        cantidad_total_boletos: parseInt(formData.cantidad_total_boletos),
        porcentaje_comision: parseFloat(formData.porcentaje_comision)
      };
      
      if (editingSorteoId) {
        // Modo edición
        await axios.put(`${API}/admin/sorteo/${editingSorteoId}`, sorteoData);
        toast.success('¡Sorteo actualizado exitosamente!');
      } else {
        // Modo creación
        await axios.post(`${API}/sorteos`, sorteoData);
        toast.success('¡Sorteo creado exitosamente!');
      }
      
      setShowCreateModal(false);
      setEditingSorteoId(null);
      fetchData();
      setFormData({
        titulo: '', descripcion: '', precio_boleto: '', cantidad_minima_boletos: '',
        cantidad_total_boletos: '', tipo: 'unico', porcentaje_comision: '10',
        color_primario: '#4F46E5',
        color_secundario: '#06B6D4', reglas: '', imagenes: [], etapas: [], premios: []
      });
      setImagenUrl('');
      setVideoUrl('');
      setEtapaForm({ 
        numero: 1, 
        porcentaje: '', 
        premio: '', 
        nombre: '',
        imagen_urls: [],
        video_urls: []
      });
    } catch (error) {
      toast.error(error.response?.data?.detail || `Error al ${editingSorteoId ? 'actualizar' : 'crear'} sorteo`);
    }
  };

  // Función helper para mostrar diálogos de confirmación (reemplaza window.confirm)
  const showConfirm = (title, message, onConfirm) => {
    setConfirmDialog({ open: true, title, message, onConfirm });
  };

  const ejecutarSorteo = async (sorteoId, etapaNumero = null) => {
    showConfirm(
      'Ejecutar Sorteo',
      '¿Estás seguro de ejecutar este sorteo?',
      async () => {
        try {
          await axios.post(`${API}/admin/ejecutar-sorteo`, 
            { sorteo_id: sorteoId, etapa_numero: etapaNumero });
          toast.success('¡Sorteo ejecutado exitosamente!');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al ejecutar sorteo');
        }
      }
    );
  };

  const editarSorteo = async (sorteoId) => {
    try {
      // Obtener los datos del sorteo
      const response = await axios.get(`${API}/sorteos/${sorteoId}`);
      const sorteo = response.data;
      
      // Formatear fechas para el input datetime-local
      const formatDateForInput = (dateString) => {
        const date = new Date(dateString);
        return date.toISOString().slice(0, 16);
      };
      
      // Cargar datos en el formulario
      // Usar fecha_cierre o fecha_inicio (compatibilidad)
      const fechaSorteo = sorteo.fecha_cierre || sorteo.fecha_inicio;
      
      setFormData({
        titulo: sorteo.titulo,
        descripcion: sorteo.descripcion,
        precio_boleto: sorteo.precio_boleto.toString(),
        cantidad_minima_boletos: sorteo.cantidad_minima_boletos.toString(),
        cantidad_total_boletos: sorteo.cantidad_total_boletos.toString(),
        tipo: sorteo.tipo,
        porcentaje_comision: sorteo.porcentaje_comision.toString(),
        color_primario: sorteo.color_primario,
        color_secundario: sorteo.color_secundario,
        reglas: sorteo.reglas || '',
        imagenes: sorteo.imagenes || [],
        etapas: sorteo.etapas || [],
        premios: sorteo.premios || []
      });
      
      setEditingSorteoId(sorteoId);
      setShowCreateModal(true);
      toast.info('Editando sorteo en borrador');
    } catch (error) {
      toast.error('Error al cargar datos del sorteo');
      console.error(error);
    }
  };

  const eliminarSorteo = async (sorteoId) => {
    const sorteo = sorteos.find(s => s.id === sorteoId);
    // Cambiado de boletos_vendidos a cantidad_reservada para ser consistente con el backend
    // cantidad_reservada incluye todos los boletos en DB (aprobados + pendientes)
    const boletosExistentes = (sorteo?.cantidad_reservada ?? 0) || (sorteo?.cantidad_vendida ?? 0);
    
    let titulo = 'Eliminar Sorteo';
    let mensaje = '¿Estás seguro de eliminar este sorteo? Esta acción no se puede deshacer.';
    
    if (boletosExistentes > 0) {
      titulo = '⚠️ Eliminar Sorteo con Boletos';
      mensaje = `Este sorteo tiene boletos asociados en el sistema.\n\n¿Estás seguro de eliminar este sorteo junto con TODOS sus boletos registrados? Esta acción NO se puede deshacer.`;
    }
    
    showConfirm(titulo, mensaje, async () => {
      try {
        const url = boletosExistentes > 0 
          ? `${API}/admin/sorteo/${sorteoId}?confirmar_con_compras=true`
          : `${API}/admin/sorteo/${sorteoId}`;
        await axios.delete(url);
        toast.success('Sorteo eliminado exitosamente');
        fetchData();
      } catch (error) {
        toast.error(error.response?.data?.detail || 'Error al eliminar sorteo');
      }
    });
  };

  const publicarSorteo = async (sorteoId) => {
    showConfirm(
      'Publicar Sorteo',
      '¿Deseas publicar este sorteo? Una vez publicado, no podrá ser editado.',
      async () => {
        try {
          await axios.put(`${API}/admin/sorteo/${sorteoId}/publicar`);
          toast.success('¡Sorteo publicado exitosamente!');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al publicar sorteo');
        }
      }
    );
  };

  const pausarDespausarVentas = async (sorteoId, pausar) => {
    try {
      await axios.put(`${API}/admin/sorteo/${sorteoId}/pausar-ventas?pausar=${pausar}`);
      toast.success(pausar ? 'Ventas pausadas' : 'Ventas reanudadas');
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al pausar/despausar ventas');
    }
  };

  const ocultarSorteo = async (sorteoId) => {
    try {
      const response = await axios.put(`${API}/admin/sorteo/${sorteoId}/ocultar`);
      toast.success(response.data.message);
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al ocultar/mostrar sorteo');
    }
  };

  const abrirConfigOperativa = (sorteo) => {
    setNuevoTotalBoletos(sorteo.cantidad_total_boletos);
    setNuevoMinimoBoletos(sorteo.cantidad_minima_boletos || 1);
    setNuevoPorcentajeManual(sorteo.porcentaje_cierre_manual || 100);
    setConfigOperativa(sorteo);
  };

  const guardarConfigOperativa = async () => {
    if (!configOperativa || loadingConfig) return;
    
    // Validación local básica adicional
    if (nuevoTotalBoletos < configOperativa.cantidad_vendida) {
      toast.error(`El total (${nuevoTotalBoletos}) no puede ser menor a los vendidos (${configOperativa.cantidad_vendida})`);
      return;
    }

    if (nuevoPorcentajeManual < 1 || nuevoPorcentajeManual > 100) {
      toast.error("El porcentaje de cierre manual debe estar entre 1 y 100");
      return;
    }

    setLoadingConfig(true);
    try {
      await axios.put(`${API}/admin/sorteo/${configOperativa.id}/config-operativa`, {
        cantidad_total_boletos: nuevoTotalBoletos,
        cantidad_minima_boletos: nuevoMinimoBoletos,
        porcentaje_cierre_manual: nuevoPorcentajeManual
      });
      
      toast.success('Configuración operativa actualizada');
      setConfigOperativa(null);
      await fetchData(); // Recargar datos reales
    } catch (error) {
      console.error('Error al guardar config:', error);
      const detail = error.response?.data?.detail;
      const msg = typeof detail === 'string' 
        ? detail 
        : Array.isArray(detail) 
          ? detail.map(d => d.msg).join(', ') 
          : 'Error al guardar configuración';
      
      toast.error(msg);
    } finally {
      setLoadingConfig(false);
    }
  };

  const cerrarConfigOperativa = () => {
    if (loadingConfig) return;
    setConfigOperativa(null);
    // No hacer NADA más, simplemente cerrar y descartar estados locales
  };

  const ejecutarCierreManual = async (sorteoId) => {
    showConfirm(
      'Cierre Manual de Sorteo',
      '¿Estás seguro de cerrar este sorteo manualmente? Se ejecutará la selección de ganadores inmediatamente con los boletos vendidos hasta ahora.',
      async () => {
        try {
          await axios.post(`${API}/admin/sorteo/${sorteoId}/cerrar-manual`);
          toast.success('Sorteo cerrado exitosamente');
          setConfigOperativa(null);
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al cerrar sorteo');
        }
      }
    );
  };

  // Función removida - reemplazada por la sección expandible de edición de imágenes

  const iniciarSorteo = async (sorteoId) => {
    showConfirm(
      'Iniciar Sorteo LIVE',
      '¿Iniciar el sorteo en LIVE ahora? Esto iniciará la animación de 2 minutos.',
      async () => {
        try {
          await axios.put(`${API}/admin/sorteo/${sorteoId}/iniciar-live`);
          toast.success('¡Sorteo iniciado en LIVE! La animación durará 2 minutos');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al iniciar sorteo');
        }
      }
    );
  };

  const finalizarSorteo = async (sorteoId) => {
    showConfirm(
      'Finalizar Sorteo',
      '¿Forzar finalización del sorteo?',
      async () => {
        try {
          await axios.put(`${API}/admin/sorteo/${sorteoId}/estado?nuevo_estado=completed`);
          toast.success('Sorteo finalizado');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al finalizar sorteo');
        }
      }
    );
  };

  const cambiarRoleUsuario = async (userId, newRole) => {
    try {
      await axios.put(`${API}/admin/usuario/${userId}/role?role=${newRole}`);
      toast.success('Role actualizado exitosamente');
      fetchData();
    } catch (error) {
      toast.error('Error al actualizar role');
    }
  };

  const bloquearUsuario = async (userId) => {
    showConfirm(
      'Bloquear Usuario',
      '¿Estás seguro de bloquear este usuario?',
      async () => {
        try {
          await axios.put(`${API}/admin/usuario/${userId}/bloquear`);
          toast.success('Usuario bloqueado exitosamente');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al bloquear usuario');
        }
      }
    );
  };

  const desbloquearUsuario = async (userId) => {
    try {
      await axios.put(`${API}/admin/usuario/${userId}/desbloquear`);
      toast.success('Usuario desbloqueado exitosamente');
      fetchData();
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al desbloquear usuario');
    }
  };

  const eliminarUsuario = async (userId) => {
    showConfirm(
      'Eliminar Usuario',
      '¿Estás seguro de eliminar este usuario? Esta acción no se puede deshacer.',
      async () => {
        try {
          await axios.delete(`${API}/admin/usuario/${userId}`);
          toast.success('Usuario eliminado exitosamente');
          fetchData();
        } catch (error) {
          toast.error(error.response?.data?.detail || 'Error al eliminar usuario');
        }
      }
    );
  };

  const fetchBoletosPendientes = async (page = pendientesPage) => {
    setLoadingPendientes(true);
    try {
      const response = await axios.get(`${API}/admin/boletos-pendientes?page=${page}&limit=10`);
      if (response.data.boletos) {
        setBoletosPendientes(response.data.boletos);
        setPendientesTotalPages(response.data.total_pages || 1);
        setPendientesTotal(response.data.total || 0);
        setPendientesPage(page);
      } else {
        setBoletosPendientes(Array.isArray(response.data) ? response.data : []);
        setPendientesTotal(0);
      }
    } catch (error) {
      console.error('Error al cargar boletos pendientes:', error);
    } finally {
      setLoadingPendientes(false);
    }
  };

  const fetchBoletosAprobados = async (sorteoId = sorteoFiltroAprobados, numeroBoleto = numeroBoletoFiltro, page = 1) => {
    setLoadingAprobados(true);
    try {
      const sParam = sorteoId && sorteoId !== 'all' ? `&sorteo_id=${sorteoId}` : '';
      const nParam = numeroBoleto ? `&numero_boleto=${numeroBoleto}` : '';
      
      const response = await axios.get(
        `${API}/admin/boletos-aprobados?page=${page}&limit=10${sParam}${nParam}`);
      
      setBoletosAprobados(response.data.boletos);
      setAprobadosTotalPages(response.data.total_pages);
      setAprobadosTotal(response.data.total);
      setAprobadosPage(page);
    } catch (error) {
      console.error('Error al cargar boletos aprobados:', error);
      toast.error('Error al cargar boletos aprobados');
    } finally {
      setLoadingAprobados(false);
    }
  };

  const handleAprobarBoleto = async () => {
    if (!numeroComprobante || !numeroComprobante.trim()) {
      toast.error('El número de comprobante es obligatorio');
      return;
    }
    
    setIsApproving(true);
    const boletoId = boletoAprobar;
    const comprobanteUsado = numeroComprobante.trim();
    
    try {
      const response = await axios.put(
        `${API}/admin/boleto/${boletoId}/aprobar?numero_comprobante=${encodeURIComponent(comprobanteUsado)}`, 
        {});
      
      const { message, warning, success, cliente, sorteo_titulo, numeros_boletos } = response.data;

      if (success === true || (message && message.includes('✅'))) {
        if (warning) {
          toast.warning(warning, { duration: 6000 });
        }
        toast.success(message || 'Compra aprobada exitosamente');

        // Guardar datos para el botón de WhatsApp post-aprobación
        setWaPostApproval({
          cliente: cliente || {},
          sorteo_titulo: sorteo_titulo || '',
          numeros_boletos: numeros_boletos || [],
          comprobante: comprobanteUsado,
          ts: new Date().toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' }),
        });

        // Limpiar y cerrar
        setNumeroComprobante('');
        setBoletoAprobar(null);
        setDialogAprobarOpen(false);
        
        // Remover localmente de pendientes y recargar en segundo plano
        setBoletosPendientes(prev => prev.filter(b => b.id !== boletoId));
        fetchBoletosPendientes();
        fetchData();
        if (typeof fetchBoletosAprobados === 'function') fetchBoletosAprobados();
        if (boletosUsuarioModalOpen && usuarioSeleccionadoBoletos) {
          fetchBoletosUsuario(usuarioSeleccionadoBoletos.id);
        }
      } else {
        toast.error(message || 'La aprobación no fue confirmada por el servidor');
      }
    } catch (error) {
      console.error('Error al aprobar:', error);
      const detail = error.response?.data?.detail;
      if (!error.response) {
        toast.error('Error de conexión. Verifica si la compra se aprobó al recargar.');
      } else {
        toast.error(detail || 'Error al aprobar boleto');
      }
    } finally {
      setIsApproving(false);
    }
  };

  const handleRechazarBoleto = async (boletoId, groupData) => {
    showConfirm(
      'Rechazar Boleto',
      '¿Estás seguro de rechazar este boleto? Se eliminará permanentemente.',
      async () => {
        setIsRejecting(true);
        try {
          const resp = await axios.put(`${API}/admin/boleto/${boletoId}/rechazar`);
          toast.success('Boleto rechazado');
          // Guardar datos para el mensaje de WhatsApp
          const { cliente, sorteo_titulo, numeros_boletos } = resp.data || {};
          setWaPostRejection({
            cliente: cliente || (groupData ? { nombre: groupData.usuario?.nombre, celular: groupData.usuario?.celular } : {}),
            sorteo_titulo: sorteo_titulo || '',
            numeros_boletos: numeros_boletos || (groupData ? groupData.group.map(b => b.numero_boleto) : []),
            ts: new Date().toLocaleString('es-EC', { dateStyle: 'short', timeStyle: 'short' }),
          });
          setBoletosPendientes(prev => prev.filter(b => b.id !== boletoId));
          fetchBoletosPendientes();
          fetchData();
          if (typeof fetchBoletosAprobados === 'function') fetchBoletosAprobados();
          if (boletosUsuarioModalOpen && usuarioSeleccionadoBoletos) {
            fetchBoletosUsuario(usuarioSeleccionadoBoletos.id);
          }
        } catch (error) {
          toast.error('Error al rechazar boleto');
        } finally {
          setIsRejecting(false);
        }
      }
    );
  };

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (passwordNueva !== passwordConfirm) {
      toast.error('Las contraseñas no coinciden');
      return;
    }
    try {
      await axios.put(`${API}/auth/cambiar-password?password_actual=${passwordActual}&password_nueva=${passwordNueva}`);
      toast.success('Contraseña cambiada exitosamente');
      setShowChangePassword(false);
      setPasswordActual('');
      setPasswordNueva('');
      setPasswordConfirm('');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Error al cambiar contraseña');
    }
  };

  // ===== WhatsApp Helper Functions =====
  const buildWAUrl = (celular, mensaje) => {
    // Limpiar número: quitar todo excepto dígitos y "+", asegurar código de país
    const raw = (celular || '').replace(/\s/g, '').replace(/-/g, '');
    const numero = raw.startsWith('+') ? raw.slice(1) : raw.startsWith('0') ? '593' + raw.slice(1) : raw || '593';
    const encoded = encodeURIComponent(mensaje);
    return `https://wa.me/${numero}?text=${encoded}`;
  };

  const waAvisoRevision = (data) => {
    const { nombresorteo, cliente, numeros_boletos, totalMonto } = data;
    const lista = (numeros_boletos || []).map(n => `#${String(n).padStart(4, '0')}`).join(', ');
    return `🎟️ *WISHWAY – Compra Recibida*\n\nHola *${cliente?.nombre || 'cliente'}*, hemos recibido tu solicitud de compra.\n\n📋 *Sorteo:* ${nombresorteo}\n🎫 *Boletos reservados:* ${lista || 'Ver detalle'}\n📦 *Cantidad:* ${numeros_boletos?.length || 0} boleto(s)\n\n⏳ Tu compra está siendo revisada. En breve nuestro equipo validará la información y, si todo está correcto, tus boletos serán aprobados.\n\nGracias por tu confianza. ✨`;
  };

  const waConfirmacionAprobacion = (wa) => {
    const lista = (wa.numeros_boletos || []).map(n => `  • #${String(n).padStart(4, '0')}`).join('\n');
    return `✅ *WISHWAY – Compra Aprobada*\n\nHola *${wa.cliente?.nombre || 'cliente'}*, tu compra ha sido *aprobada exitosamente*.\n\n━━━━━━━━━━━━━━━━\n📋 *Sorteo:* ${wa.sorteo_titulo}\n🎫 *Boletos aprobados:*\n${lista || '  • Ver detalle'}\n📦 *Cantidad:* ${wa.numeros_boletos?.length || 0} boleto(s)\n🧾 *Comprobante:* ${wa.comprobante}\n📅 *Fecha:* ${wa.ts}\n━━━━━━━━━━━━━━━━\n\n🟢 Tus boletos ya están *activos* para participar en el sorteo. ¡Mucha suerte! 🍀\n\nWishWay – Sorteos con propósito.`;
  };

  const waNotificacionRechazo = (wa) => {
    const lista = (wa.numeros_boletos || []).map(n => `  • #${String(n).padStart(4, '0')}`).join('\n');
    return `❌ *WISHWAY – Solicitud No Aprobada*\n\nHola *${wa.cliente?.nombre || 'cliente'}*, lamentamos informarte que tu solicitud no pudo ser procesada.\n\n━━━━━━━━━━━━━━━━\n📋 *Sorteo:* ${wa.sorteo_titulo}\n🎫 *Boletos rechazados:*\n${lista || '  • Ver detalle'}\n📦 *Cantidad:* ${wa.numeros_boletos?.length || 0} boleto(s)\n📅 *Fecha:* ${wa.ts}\n━━━━━━━━━━━━━━━━\n\nPara más información o para realizar una nueva compra, comunícate con nuestro equipo de soporte. Estamos para ayudarte.\n\nWishWay – Sorteos con propósito.`;
  };

  return (
    <div className="min-h-screen gradient-background">
      <div className="bg-card shadow-sm border-b sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-6">
            <div className="flex items-center gap-3 w-full md:w-auto">
              <div className="w-12 h-12 rounded-full bg-red-600 text-white flex items-center justify-center font-bold text-xl shadow-lg">A</div>
              <div>
                <h1 className="text-lg md:text-2xl font-bold text-foreground">Panel de Administración</h1>
                <p className="text-sm text-muted-foreground">{user?.email}</p>
              </div>
            </div>
            <div className="flex flex-wrap gap-2 w-full md:w-auto items-center justify-start md:justify-end">
              <ThemeToggle />
              
              <Dialog open={showContactoModal} onOpenChange={setShowContactoModal}>
                <DialogTrigger asChild>
                  <AppButton variant="secondary" size="sm" icon={MessageCircle} className="px-3 md:px-4">
                    <span className="hidden sm:inline">Contacto</span>
                  </AppButton>
                </DialogTrigger>
                <DialogContent className="bg-card text-foreground">
                  <DialogHeader>
                    <DialogTitle>Botón de Contacto</DialogTitle>
                    <DialogDescription>Configura dónde enviará a los usuarios el botón de WhatsApp/Instagram.</DialogDescription>
                  </DialogHeader>
                  <form onSubmit={handleSaveContacto} className="space-y-4">
                    <div>
                      <Label>Plataforma</Label>
                      <Select 
                        value={contactoData.tipo_contacto} 
                        onValueChange={(val) => setContactoData(prev => ({ ...prev, tipo_contacto: val }))}
                      >
                        <SelectTrigger>
                          <SelectValue placeholder="Selecciona..." />
                        </SelectTrigger>
                        <SelectContent>
                          <SelectItem value="whatsapp">WhatsApp</SelectItem>
                          <SelectItem value="instagram">Instagram</SelectItem>
                        </SelectContent>
                      </Select>
                    </div>
                    <div>
                      <Label>Enlace o Usuario</Label>
                      <Input 
                        value={contactoData.valor_contacto} 
                        onChange={(e) => setContactoData(prev => ({ ...prev, valor_contacto: e.target.value }))} 
                        required 
                        placeholder={contactoData.tipo_contacto === 'whatsapp' ? 'Ej: 593939603823' : 'Ej: wishway.oficial'}
                      />
                      <p className="text-xs text-muted-foreground mt-1">
                        {contactoData.tipo_contacto === 'whatsapp' ? 'Ingresa tu número con código de país. Ej: 593939603823' : 'Ingresa solo tu nombre de usuario. Ej: wishway.oficial'}
                      </p>
                    </div>
                    <Button type="submit" disabled={isSavingContacto} className="w-full">
                      {isSavingContacto ? 'Guardando...' : 'Guardar Configuración'}
                    </Button>
                  </form>
                </DialogContent>
              </Dialog>

              <Dialog open={showChangePassword} onOpenChange={setShowChangePassword}>
                <DialogTrigger asChild>
                  <AppButton variant="secondary" size="sm" data-testid="change-password-btn" icon={Key} className="px-3 md:px-4">
                    <span className="hidden sm:inline">Cambiar Contraseña</span>
                    <span className="sm:hidden">Pass</span>
                  </AppButton>
                </DialogTrigger>
                <DialogContent className="bg-card text-foreground">
                  <DialogHeader>
                    <DialogTitle>Cambiar Contraseña</DialogTitle>
                  </DialogHeader>
                  <form onSubmit={handleChangePassword} className="space-y-4">
                    <div>
                      <Label htmlFor="password-actual">Contraseña Actual</Label>
                      <Input id="password-actual" type="password" value={passwordActual} onChange={(e) => setPasswordActual(e.target.value)} required />
                    </div>
                    <div>
                      <Label htmlFor="password-nueva">Nueva Contraseña</Label>
                      <Input id="password-nueva" type="password" value={passwordNueva} onChange={(e) => setPasswordNueva(e.target.value)} required />
                    </div>
                    <div>
                      <Label htmlFor="password-confirm">Confirmar Nueva Contraseña</Label>
                      <Input id="password-confirm" type="password" value={passwordConfirm} onChange={(e) => setPasswordConfirm(e.target.value)} required />
                    </div>
                    <div className="flex gap-2 justify-end">
                      <AppButton variant="ghost" onClick={() => setShowChangePassword(false)}>Cancelar</AppButton>
                      <AppButton type="submit">Cambiar Contraseña</AppButton>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
              <AppButton variant="secondary" size="sm" onClick={() => navigate('/admin/perfil')} data-testid="perfil-btn" icon={Settings} className="px-3 md:px-4">
                <span className="hidden lg:inline">Configuración</span>
              </AppButton>
              <AppButton variant="secondary" size="sm" onClick={() => navigate('/')} data-testid="home-btn" icon={Home} className="px-3 md:px-4">
                <span className="hidden lg:inline">Inicio</span>
              </AppButton>
              <AppButton 
                variant="danger" 
                size="sm"
                onClick={handleLogout} 
                data-testid="logout-btn" 
                icon={LogOut}
                className="px-3 md:px-4"
                title="Salir"
              >
                <span className="hidden lg:inline">Salir</span>
              </AppButton>
            </div>
          </div>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 py-8">
        {/* Tarjetas de estadísticas */}
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
          <StatCard 
            title="Sorteos Activos"
            value={sorteos.filter(s => s.estado === 'activo' || s.estado === 'published').length}
            icon={Activity}
            color="orange"
          />
          <StatCard 
            title="Total Sorteos"
            value={sorteos.length}
            icon={Trophy}
            color="red"
          />
          <StatCard 
            title="Usuarios"
            value={usuariosTotal || usuarios.length}
            icon={Users}
            color="green"
          />
          <StatCard 
            title="Visitas Totales" 
            value={globalStats.visitas_totales} 
            icon={Eye} 
            color="purple"
          />
          <StatCard 
            title="Visitas de Hoy" 
            value={globalStats.visitas_hoy} 
            icon={TrendingUp} 
            color="cyan"
          />
          <StatCard 
            title="Vendedores"
            value={usuarios.filter(u => u.role === 'vendedor').length}
            icon={DollarSign}
            color="gold"
          />
        </div>

        <Tabs defaultValue="sorteos" className="space-y-4">
          <TabsNav tabs={[
            { label: 'Sorteos', value: 'sorteos', testId: 'tab-sorteos' },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Usuarios ({usuariosTotal})</span>
                  <span className="sm:hidden">Usuarios</span>
                </>
              ), 
              value: 'usuarios', 
              testId: 'tab-usuarios' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Retiros de Vendedores</span>
                  <span className="sm:hidden">Retiros</span>
                </>
              ), 
              value: 'retiros', 
              testId: 'tab-retiros' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Boletos Pendientes</span>
                  <span className="sm:hidden">Pendientes</span>
                </>
              ), 
              value: 'pendientes', 
              testId: 'tab-pendientes',
              badge: pendientesTotal > 0 ? pendientesTotal : null
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Boletos Aprobados</span>
                  <span className="sm:hidden">Aprobados</span>
                </>
              ), 
              value: 'aprobados', 
              testId: 'tab-aprobados' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Pasarela</span>
                  <span className="sm:hidden">Pagos</span>
                </>
              ), 
              value: 'payphone', 
              testId: 'tab-payphone' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">PayPal</span>
                  <span className="sm:hidden">PayPal</span>
                </>
              ), 
              value: 'paypal', 
              testId: 'tab-paypal' 
            },
            { label: 'Hero Home', value: 'hero', testId: 'tab-hero' },
            { label: 'Logo / Branding', value: 'branding', testId: 'tab-branding' },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Campañas</span>
                  <span className="sm:hidden">Marketing</span>
                </>
              ), 
              value: 'campanas', 
              testId: 'tab-campanas' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Respaldos</span>
                  <span className="sm:hidden">Backup</span>
                </>
              ), 
              value: 'respaldos', 
              testId: 'tab-respaldos' 
            },
            { 
              label: (
                <>
                  <span className="hidden sm:inline">Píxel FB</span>
                  <span className="sm:hidden">Píxel</span>
                </>
              ), 
              value: 'marketing', 
              testId: 'tab-marketing' 
            }
          ]} />

          <TabsContent value="sorteos" className="space-y-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Gestión de <span className="text-orange-500">Sorteos</span></h2>
              <Dialog open={showCreateModal} onOpenChange={(open) => {
                setShowCreateModal(open);
                if (!open) {
                  // Resetear al cerrar
                  setEditingSorteoId(null);
                  setFormData({
                    titulo: '', descripcion: '', precio_boleto: '', cantidad_minima_boletos: '',
                    cantidad_total_boletos: '', tipo: 'unico', porcentaje_comision: '10',
                    color_primario: '#4F46E5',
                    color_secundario: '#06B6D4', reglas: '', imagenes: [], etapas: [], premios: []
                  });
                  setImagenUrl('');
                  setVideoUrl('');
                }
              }}>
                <DialogTrigger asChild>
                  <AppButton 
                    size="lg" 
                    data-testid="crear-sorteo-btn" 
                    icon={Plus}
                    className="bg-[#f15a24] hover:bg-[#d44d1d] text-white shadow-xl shadow-orange-600/20 px-6 py-6 text-sm font-black uppercase tracking-wider translate-y-0 active:scale-95"
                  >
                    Crear Sorteo
                  </AppButton>
                </DialogTrigger>
                <DialogContent className="max-w-3xl max-h-[90vh] overflow-y-auto bg-white dark:bg-slate-950/95 backdrop-blur-xl border-slate-200 dark:border-white/10 text-slate-900 dark:text-white rounded-xl shadow-[0_0_50px_rgba(0,0,0,0.1)] dark:shadow-[0_0_50px_rgba(0,0,0,0.5)] custom-scrollbar">
                  <DialogHeader className="mb-6">
                    <DialogTitle className="text-3xl font-black tracking-tighter uppercase italic">
                      {editingSorteoId ? 'Editar' : 'Crear'} <span className="text-orange-500">Sorteo</span>
                    </DialogTitle>
                    <DialogDescription className="text-slate-500 dark:text-slate-400 font-medium">
                      {editingSorteoId ? 'Modifica los parámetros estratégicos del sorteo.' : 'Define la configuración de tu próximo gran lanzamiento.'}
                    </DialogDescription>
                  </DialogHeader>
                  
                  <form onSubmit={handleCrearSorteo} className="space-y-4">
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 bg-slate-50 dark:bg-white/5 p-6 rounded-xl border border-slate-200 dark:border-white/5 shadow-inner">
                      <div className="md:col-span-2 space-y-2">
                        <Label htmlFor="titulo" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Título del Sorteo</Label>
                        <Input 
                          id="titulo" name="titulo" 
                          value={formData.titulo} onChange={handleInputChange} 
                          required data-testid="titulo-input"
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-14 rounded-lg focus:ring-orange-500 focus:border-orange-500 font-bold text-lg text-slate-900 dark:text-white"
                        />
                      </div>
                      <div className="md:col-span-2 space-y-2">
                        <Label htmlFor="descripcion" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Descripción Persuasiva</Label>
                        <Textarea 
                          id="descripcion" name="descripcion" 
                          value={formData.descripcion} onChange={handleInputChange} 
                          rows={3} required
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg focus:ring-orange-500 focus:border-orange-500 font-medium resize-none text-slate-900 dark:text-white"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="precio_boleto" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Precio Boleto ($)</Label>
                        <Input 
                          id="precio_boleto" name="precio_boleto" 
                          type="number" step="0.01" 
                          value={formData.precio_boleto} onChange={handleInputChange} 
                          required 
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-12 rounded-lg focus:ring-orange-500 text-slate-900 dark:text-white"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="porcentaje_comision" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Comisión Vendedor (%)</Label>
                        <Input 
                          id="porcentaje_comision" name="porcentaje_comision" 
                          type="number" step="0.1" 
                          value={formData.porcentaje_comision} onChange={handleInputChange} 
                          required 
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-12 rounded-lg focus:ring-orange-500 text-slate-900 dark:text-white"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="cantidad_minima_boletos" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Mínimo de Boletos</Label>
                        <Input 
                          id="cantidad_minima_boletos" name="cantidad_minima_boletos" 
                          type="number" 
                          value={formData.cantidad_minima_boletos} onChange={handleInputChange} 
                          required 
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-12 rounded-lg focus:ring-orange-500 text-slate-900 dark:text-white"
                        />
                      </div>
                      <div className="space-y-2">
                        <Label htmlFor="cantidad_total_boletos" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Total de Boletos</Label>
                        <Input 
                          id="cantidad_total_boletos" name="cantidad_total_boletos" 
                          type="number" 
                          value={formData.cantidad_total_boletos} onChange={handleInputChange} 
                          required 
                          className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-12 rounded-lg focus:ring-orange-500 text-slate-900 dark:text-white"
                        />
                      </div>

                      <div className="md:col-span-2 space-y-2">
                        <Label htmlFor="tipo" className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Formato de Juego</Label>
                        <Select value={formData.tipo} onValueChange={(value) => setFormData(prev => ({ ...prev, tipo: value }))}>
                          <SelectTrigger className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 h-12 rounded-xl focus:ring-orange-500 text-slate-900 dark:text-white">
                            <SelectValue placeholder="Seleccionar tipo..." />
                          </SelectTrigger>
                          <SelectContent className="bg-white dark:bg-slate-900 border-slate-200 dark:border-white/10 text-slate-900 dark:text-white">
                            <SelectItem value="unico">Individual (Un Ganador)</SelectItem>
                            <SelectItem value="etapas">Progresivo (Varias Etapas)</SelectItem>
                          </SelectContent>
                        </Select>
                      </div>
                    </div>



                    {/* Sección de videos eliminada - los videos van en cada premio individual */}

                    {/* Sección de Premios para Sorteo Único */}
                    {formData.tipo === 'unico' && (
                      <div className="md:col-span-2 bg-slate-50 dark:bg-white/5 p-6 rounded-xl border border-slate-200 dark:border-white/5 space-y-4 font-inter">
                        <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Premios Exclusivos</h3>
                        
                        {/* Lista de premios agregados */}
                        {formData.premios && formData.premios.length > 0 && (
                          <div className="space-y-3">
                            {formData.premios.map((premio, index) => (
                              <div key={index} className="p-4 bg-white dark:bg-slate-900/40 rounded-lg border border-slate-200 dark:border-white/10 flex items-start justify-between group">
                                <div className="flex-1">
                                  <p className="font-bold text-slate-900 dark:text-white tracking-tight italic uppercase">{premio.nombre}</p>
                                  {premio.descripcion && <p className="text-xs text-slate-500 dark:text-slate-400 font-medium">{premio.descripcion}</p>}
                                  <div className="flex gap-2 mt-2">
                                     {premio.imagen_url && <span className="text-[9px] font-black bg-blue-500/10 text-blue-500 px-2 py-0.5 rounded uppercase">✓ Imagen</span>}
                                     {premio.video_url && <span className="text-[9px] font-black bg-purple-500/10 text-purple-500 px-2 py-0.5 rounded uppercase">✓ Video</span>}
                                  </div>
                                </div>
                                <AppButton 
                                  type="button" 
                                  variant="ghost" 
                                  className="h-10 w-10 p-0 rounded-md hover:bg-red-500/10 text-red-500 border-0 shadow-none bg-transparent"
                                  onClick={() => eliminarPremio(index)}
                                >
                                  <Trash2 className="w-5 h-5" />
                                </AppButton>
                              </div>
                            ))}
                          </div>
                        )}

                        {/* Formulario para agregar nuevo premio */}
                        <div className="bg-orange-500/[0.03] dark:bg-orange-500/5 p-5 rounded-lg border border-orange-500/10 dark:border-orange-500/20 space-y-4">
                          <h4 className="text-[11px] font-black tracking-widest text-orange-500 dark:text-orange-400 uppercase ml-2">Agregar Recompensa</h4>
                          
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">Nombre del Premio *</Label>
                              <Input 
                                placeholder="Ej: iPhone 15 Pro Max" 
                                value={premioForm.nombre} 
                                onChange={(e) => setPremioForm(prev => ({ ...prev, nombre: e.target.value }))} 
                                className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg h-11 text-slate-900 dark:text-white"
                              />
                            </div>
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">Descripción (opcional)</Label>
                              <Input 
                                placeholder="Color, capacidad, extras..." 
                                value={premioForm.descripcion} 
                                onChange={(e) => setPremioForm(prev => ({ ...prev, descripcion: e.target.value }))} 
                                className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg h-11 text-slate-900 dark:text-white"
                              />
                            </div>
                          </div>

                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">Fotografía del Premio</Label>
                              <div className="flex items-center gap-3">
                                {premioForm.imagen_url ? (
                                  <div className="relative group/img h-11 w-11 rounded-lg overflow-hidden border border-slate-200 dark:border-white/10 shrink-0">
                                    <img src={getMediaUrl(premioForm.imagen_url)} alt="Premio" className="w-full h-full object-cover" />
                                    <button 
                                      type="button"
                                      onClick={() => setPremioForm(prev => ({...prev, imagen_url: ''}))}
                                      className="absolute inset-0 bg-red-500/80 text-white opacity-0 group-hover/img:opacity-100 flex items-center justify-center transition-opacity"
                                    >
                                      <Trash2 className="w-4 h-4" />
                                    </button>
                                  </div>
                                ) : (
                                  <div className="h-11 w-11 rounded-lg border-2 border-dashed border-slate-200 dark:border-white/10 flex items-center justify-center text-slate-400 shrink-0">
                                    <Image className="w-5 h-5" />
                                  </div>
                                )}
                                <div className="flex-1 relative">
                                  <Input 
                                    type="file" 
                                    id="file-upload-premio" 
                                    className="hidden" 
                                    onChange={handleUploadPremioImage}
                                    accept="image/*"
                                  />
                                  <Label 
                                    htmlFor="file-upload-premio"
                                    className={`flex items-center justify-center gap-2 h-11 w-full rounded-lg border border-slate-200 dark:border-white/10 text-[10px] font-black uppercase tracking-widest cursor-pointer transition-all ${
                                      isUploadingPremio ? 'bg-slate-50 opacity-50' : 'bg-white dark:bg-slate-900/50 hover:bg-slate-50 dark:hover:bg-white/10'
                                    }`}
                                  >
                                    {isUploadingPremio ? (
                                      <>
                                        <Loader2 className="w-4 h-4 animate-spin" />
                                        Subiendo...
                                      </>
                                    ) : (
                                      <>
                                        <Camera className="w-4 h-4 text-orange-500" />
                                        {premioForm.imagen_url ? 'Cambiar Foto' : 'Subir Imagen'}
                                      </>
                                    )}
                                  </Label>
                                </div>
                              </div>
                            </div>
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">URL Video Impacto</Label>
                              <Input 
                                placeholder="https://..." 
                                type="url"
                                value={premioForm.video_url} 
                                onChange={(e) => setPremioForm(prev => ({ ...prev, video_url: e.target.value }))}
                                className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg h-11 text-slate-900 dark:text-white"
                              />
                            </div>
                          </div>

                          <AppButton 
                            type="button" 
                            onClick={agregarPremio} 
                            className="w-full py-4 text-xs font-black uppercase rounded-lg bg-[#f15a24] hover:bg-[#d44d1d] text-white shadow-lg shadow-orange-600/20"
                          >
                            + Vincular Premio al Sorteo
                          </AppButton>
                        </div>
                      </div>
                    )}

                    {formData.tipo === 'etapas' && (
                      <div className="md:col-span-2 bg-slate-50 dark:bg-white/5 p-6 rounded-[1.25rem] border border-slate-200 dark:border-white/5 space-y-4">
                        <h3 className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Estructura Progresiva</h3>
                        
                        {/* Lista de etapas agregadas */}
                        {formData.etapas.map((etapa, index) => (
                          <div key={index} className="p-5 bg-white dark:bg-slate-900/40 rounded-xl border border-slate-200 dark:border-white/10 group space-y-3">
                            <div className="flex items-start justify-between">
                              <div className="flex-1">
                                <h4 className="text-slate-900 dark:text-white font-bold tracking-tight italic uppercase text-lg">Etapa {etapa.numero}: {etapa.nombre || etapa.premio}</h4>
                                <div className="flex items-center gap-2 text-[10px] font-black uppercase text-orange-500 mt-1">
                                   <div className="w-1.5 h-1.5 rounded-full bg-orange-500 animate-pulse" />
                                   <span>Se activa al {etapa.porcentaje}% de ventas</span>
                                </div>
                              </div>
                              <AppButton 
                                type="button" 
                                variant="ghost" 
                                className="h-10 w-10 p-0 rounded-md hover:bg-red-500/10 text-red-500 border-0 shadow-none bg-transparent" 
                                onClick={() => eliminarEtapa(index)}
                              >
                                <Trash2 className="w-5 h-5" />
                              </AppButton>
                            </div>
                            
                            {/* Premios de esta etapa */}
                            {etapa.premios && etapa.premios.length > 0 && (
                              <div className="pl-4 border-l-2 border-orange-500/30 space-y-2">
                                {etapa.premios.map((premio, pIdx) => (
                                  <div key={pIdx} className="text-[10px] font-black uppercase tracking-widest bg-slate-100 dark:bg-white/5 p-2 rounded-lg flex justify-between items-center text-slate-500 dark:text-slate-400">
                                    <span>{premio.nombre}</span>
                                    <button 
                                      type="button" 
                                      onClick={() => eliminarPremioDeEtapa(index, pIdx)}
                                      className="text-red-500 hover:text-red-400 p-1"
                                    >
                                      ×
                                    </button>
                                  </div>
                                ))}
                              </div>
                            )}
                          </div>
                        ))}

                        {/* Formulario para agregar nueva etapa */}
                        <div className="bg-orange-500/[0.03] dark:bg-orange-500/5 p-6 rounded-xl border border-orange-500/10 dark:border-orange-500/20 space-y-6">
                          <h4 className="text-[11px] font-black tracking-widest text-orange-500 dark:text-orange-400 uppercase ml-2">Definir Nueva Etapa</h4>
                          
                          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">Nombre Identificador</Label>
                              <Input 
                                placeholder="Ej: Fase Inicial / Lanzamiento" 
                                value={etapaForm.nombre} 
                                onChange={(e) => setEtapaForm(prev => ({ ...prev, nombre: e.target.value }))} 
                                className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg h-11 text-slate-900 dark:text-white"
                              />
                            </div>
                            <div className="space-y-1">
                              <Label className="text-[9px] font-black text-slate-400 dark:text-slate-500 uppercase tracking-widest ml-2">Metas de Ventas %</Label>
                              <Input 
                                placeholder="Ej: 25" 
                                type="number" 
                                value={etapaForm.porcentaje} 
                                onChange={(e) => setEtapaForm(prev => ({ ...prev, porcentaje: e.target.value }))} 
                                className="bg-white dark:bg-slate-900/50 border-slate-200 dark:border-white/10 rounded-lg h-11 text-slate-900 dark:text-white"
                              />
                            </div>
                          </div>

                          {/* Formulario para agregar premio a la etapa */}
                          <div className="bg-white dark:bg-white/5 p-5 rounded-xl border border-slate-200 dark:border-white/5 space-y-4">
                            <p className="text-[10px] font-black text-slate-500 dark:text-slate-500 uppercase tracking-widest ml-2">Añadir Premio a la Etapa</p>
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div className="space-y-1">
                                <Label className="text-[9px] font-black text-slate-500 uppercase ml-2">Nombre Recompensa *</Label>
                                <Input 
                                  placeholder="Ej: Bono de $500" 
                                  value={premioForm.nombre} 
                                  onChange={(e) => setPremioForm(prev => ({ ...prev, nombre: e.target.value }))} 
                                  className="bg-slate-50 dark:bg-slate-900/50 border-slate-100 dark:border-white/5 rounded-lg h-10 text-xs text-slate-900 dark:text-white"
                                />
                              </div>
                              <div className="space-y-1">
                                <Label className="text-[9px] font-black text-slate-500 uppercase ml-2">Detalles</Label>
                                <Input 
                                  placeholder="Opcional..." 
                                  value={premioForm.descripcion} 
                                  onChange={(e) => setPremioForm(prev => ({ ...prev, descripcion: e.target.value }))} 
                                  className="bg-slate-50 dark:bg-slate-900/50 border-slate-100 dark:border-white/5 rounded-lg h-10 text-xs text-slate-900 dark:text-white"
                                />
                              </div>
                            </div>
                            
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                              <div className="space-y-1">
                                <Label className="text-[9px] font-black text-slate-500 uppercase ml-2">Fotografía</Label>
                                <div className="flex items-center gap-2">
                                  {premioForm.imagen_url ? (
                                    <div className="relative group/img h-10 w-10 rounded-lg overflow-hidden border border-slate-100 dark:border-white/5 shrink-0">
                                      <img src={getMediaUrl(premioForm.imagen_url)} alt="Premio" className="w-full h-full object-cover" />
                                      <button 
                                        type="button"
                                        onClick={() => setPremioForm(prev => ({...prev, imagen_url: ''}))}
                                        className="absolute inset-0 bg-red-500/80 text-white opacity-0 group-hover/img:opacity-100 flex items-center justify-center transition-opacity"
                                      >
                                        <Trash2 className="w-3 h-3" />
                                      </button>
                                    </div>
                                  ) : (
                                    <div className="h-10 w-10 rounded-lg border border-dashed border-slate-200 dark:border-white/5 flex items-center justify-center text-slate-400 shrink-0">
                                      <Image className="w-4 h-4" />
                                    </div>
                                  )}
                                  <div className="flex-1 relative">
                                    <Input 
                                      type="file" 
                                      id="file-upload-etapa-premio" 
                                      className="hidden" 
                                      onChange={handleUploadPremioImage}
                                      accept="image/*"
                                    />
                                    <Label 
                                      htmlFor="file-upload-etapa-premio"
                                      className={`flex items-center justify-center gap-2 h-10 w-full rounded-lg border border-slate-100 dark:border-white/5 text-[9px] font-black uppercase tracking-widest cursor-pointer transition-all ${
                                        isUploadingPremio ? 'bg-slate-50 opacity-50' : 'bg-slate-50 dark:bg-slate-900/50 hover:bg-slate-100 dark:hover:bg-white/5'
                                      }`}
                                    >
                                      {isUploadingPremio ? (
                                        <Loader2 className="w-3 h-3 animate-spin" />
                                      ) : (
                                        <>
                                          <Camera className="w-3 h-3 text-orange-500" />
                                          {premioForm.imagen_url ? 'Cambiar' : 'Subir'}
                                        </>
                                      )}
                                    </Label>
                                  </div>
                                </div>
                              </div>
                              <div className="space-y-1">
                                <Label className="text-[9px] font-black text-slate-500 uppercase ml-2">URL Video</Label>
                                <Input 
                                  placeholder="https://..." 
                                  value={premioForm.video_url} 
                                  onChange={(e) => setPremioForm(prev => ({ ...prev, video_url: e.target.value }))} 
                                  className="bg-slate-50 dark:bg-slate-900/50 border-slate-100 dark:border-white/5 rounded-lg h-10 text-xs text-slate-900 dark:text-white"
                                />
                              </div>
                            </div>
                            <AppButton 
                              type="button" 
                              onClick={() => {
                                if (!premioForm.nombre.trim()) {
                                  toast.error('El nombre del premio es obligatorio');
                                  return;
                                }
                                setEtapaForm(prev => ({ 
                                  ...prev, 
                                  premios: [...(prev.premios || []), { ...premioForm }]
                                }));
                                setPremioForm({ nombre: '', descripcion: '', imagen_url: '', video_url: '' });
                              }}
                              className="w-full py-3 text-xs uppercase font-black rounded-lg bg-[#f15a24] hover:bg-[#d44d1d] text-white shadow-md shadow-orange-600/10"
                            >
                              + Registrar Premio en Etapa
                            </AppButton>
                          </div>

                          <AppButton 
                            type="button" 
                            onClick={agregarEtapa} 
                            className="w-full py-4 text-xs font-black uppercase rounded-lg bg-[#f15a24] hover:bg-[#d44d1d] text-white shadow-lg shadow-orange-600/20"
                          >
                            + Instanciar Etapa Progresiva
                          </AppButton>
                        </div>
                      </div>
                    )}

                    <div className="flex justify-end items-center gap-4 pt-6 border-t border-slate-100 dark:border-white/10">
                      <AppButton 
                        type="button" 
                        variant="soft"
                        className="px-8 py-3 text-slate-400 hover:shadow-none translate-y-0 active:scale-100"
                        onClick={() => {
                          setShowCreateModal(false);
                          setEditingSorteoId(null);
                        }}
                      >
                        Cancelar
                      </AppButton>
                      <AppButton 
                        type="submit" 
                        data-testid="submit-sorteo-btn"
                        className="px-10 py-5 bg-[#f15a24] hover:bg-[#d44d1d] text-white shadow-[0_15px_30px_rgba(241,90,36,0.3)] font-black text-sm uppercase tracking-widest"
                      >
                        {editingSorteoId ? 'Guardar Cambios' : 'Lanzar Sorteo Ahora'}
                      </AppButton>
                    </div>
                  </form>
                </DialogContent>
              </Dialog>
            </div>

            {loading ? (
              <div className="text-center py-12">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              </div>
            ) : sorteos.length === 0 ? (
              <Card className="p-12 text-center text-slate-500">
                <Trophy className="w-16 h-16 mx-auto mb-4 opacity-20" />
                <h3 className="text-xl font-semibold mb-2 italic uppercase font-black">No hay sorteos registrados</h3>
              </Card>
            ) : (
              <div className="space-y-12">
                {/* 0. BORRADORES / EN CREACIÓN */}
                <section className="space-y-4">
                  <div className="flex items-center gap-3 border-l-4 border-slate-300 dark:border-white/20 pl-4">
                    <Layout className="w-6 h-6 text-slate-400" />
                    <h3 className="text-xl font-black uppercase tracking-widest italic text-slate-400">Borradores y en Creación</h3>
                    <Badge variant="outline" className="opacity-40">
                      {sorteos.filter(s => s.estado === 'draft').length}
                    </Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {sorteos.filter(s => s.estado === 'draft').map((sorteo) => (
                      <RaffleCard 
                        key={sorteo.id}
                        sorteo={sorteo}
                        publicarSorteo={publicarSorteo}
                        editarSorteo={editarSorteo}
                        eliminarSorteo={eliminarSorteo}
                        pausarDespausarVentas={pausarDespausarVentas}
                        abrirConfigOperativa={abrirConfigOperativa}
                        ocultarSorteo={ocultarSorteo}
                        finalizarSorteo={finalizarSorteo}
                        setSorteoExpandido={setSorteoExpandido}
                        sorteoExpandido={sorteoExpandido}
                        fetchData={fetchData}
                      />
                    ))}
                  </div>
                </section>

                {/* 1. PUBLICADOS / ACTIVOS (EN VENTA) */}
                <section className="space-y-4">
                  <div className="flex items-center gap-3 border-l-4 border-blue-500 pl-4">
                    <Banknote className="w-6 h-6 text-blue-500" />
                    <h3 className="text-xl font-black uppercase tracking-widest italic">Publicados y en Venta</h3>
                    <Badge className="bg-blue-500/10 text-blue-600 border-blue-500/20">
                      {sorteos.filter(s => (s.estado === 'published' || s.estado === 'activo' || s.estado === 'pausado')).length}
                    </Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {sorteos.filter(s => (s.estado === 'published' || s.estado === 'activo' || s.estado === 'pausado')).map((sorteo) => (
                      <RaffleCard 
                        key={sorteo.id}
                        sorteo={sorteo}
                        publicarSorteo={publicarSorteo}
                        editarSorteo={editarSorteo}
                        eliminarSorteo={eliminarSorteo}
                        pausarDespausarVentas={pausarDespausarVentas}
                        abrirConfigOperativa={abrirConfigOperativa}
                        ocultarSorteo={ocultarSorteo}
                        finalizarSorteo={finalizarSorteo}
                        setSorteoExpandido={setSorteoExpandido}
                        sorteoExpandido={sorteoExpandido}
                        fetchData={fetchData}
                      />
                    ))}
                  </div>
                </section>

                {/* 2. POR INICIAR (READY) */}
                <section className="space-y-4">
                  <div className="flex items-center gap-3 border-l-4 border-emerald-500 pl-4">
                    <Play className="w-6 h-6 text-emerald-500" />
                    <h3 className="text-xl font-black uppercase tracking-widest italic">Listos para Iniciar</h3>
                    <Badge className="bg-emerald-500/10 text-emerald-600 border-emerald-500/20">
                      {sorteos.filter(s => s.estado === 'ready').length}
                    </Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {sorteos.filter(s => s.estado === 'ready').map((sorteo) => (
                      <RaffleCard 
                        key={sorteo.id}
                        sorteo={sorteo}
                        publicarSorteo={publicarSorteo}
                        editarSorteo={editarSorteo}
                        eliminarSorteo={eliminarSorteo}
                        pausarDespausarVentas={pausarDespausarVentas}
                        abrirConfigOperativa={abrirConfigOperativa}
                        ocultarSorteo={ocultarSorteo}
                        finalizarSorteo={finalizarSorteo}
                        setSorteoExpandido={setSorteoExpandido}
                        sorteoExpandido={sorteoExpandido}
                        fetchData={fetchData}
                      />
                    ))}
                  </div>
                </section>

                {/* 3. EN VIVO (LIVE) */}
                <section className="space-y-4">
                  <div className="flex items-center gap-3 border-l-4 border-red-500 pl-4">
                    <Activity className="w-6 h-6 text-red-500" />
                    <h3 className="text-xl font-black uppercase tracking-widest italic">Sorteando en VIVO</h3>
                    <Badge className="bg-red-500/10 text-red-600 border-red-500/20">
                      {sorteos.filter(s => (s.estado === 'live' || s.estado === 'waiting')).length}
                    </Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {sorteos.filter(s => (s.estado === 'live' || s.estado === 'waiting')).map((sorteo) => (
                      <RaffleCard 
                        key={sorteo.id}
                        sorteo={sorteo}
                        publicarSorteo={publicarSorteo}
                        editarSorteo={editarSorteo}
                        eliminarSorteo={eliminarSorteo}
                        pausarDespausarVentas={pausarDespausarVentas}
                        abrirConfigOperativa={abrirConfigOperativa}
                        ocultarSorteo={ocultarSorteo}
                        finalizarSorteo={finalizarSorteo}
                        setSorteoExpandido={setSorteoExpandido}
                        sorteoExpandido={sorteoExpandido}
                        fetchData={fetchData}
                      />
                    ))}
                  </div>
                </section>

                {/* 4. FINALIZADOS */}
                <section className="space-y-4">
                  <div className="flex items-center gap-3 border-l-4 border-slate-400 pl-4">
                    <CheckCircle className="w-6 h-6 text-slate-400" />
                    <h3 className="text-xl font-black uppercase tracking-widest italic">Histórico / Finalizados</h3>
                    <Badge className="bg-slate-500/10 text-slate-500 border-slate-500/20">
                      {sorteos.filter(s => (s.estado === 'completed' || s.estado === 'completado')).length}
                    </Badge>
                  </div>
                  <div className="grid grid-cols-1 gap-6">
                    {sorteos.filter(s => (s.estado === 'completed' || s.estado === 'completado')).map((sorteo) => (
                      <RaffleCard 
                        key={sorteo.id}
                        sorteo={sorteo}
                        publicarSorteo={publicarSorteo}
                        editarSorteo={editarSorteo}
                        eliminarSorteo={eliminarSorteo}
                        pausarDespausarVentas={pausarDespausarVentas}
                        abrirConfigOperativa={abrirConfigOperativa}
                        ocultarSorteo={ocultarSorteo}
                        finalizarSorteo={finalizarSorteo}
                        setSorteoExpandido={setSorteoExpandido}
                        sorteoExpandido={sorteoExpandido}
                        fetchData={fetchData}
                      />
                    ))}
                  </div>
                </section>
              </div>
            )}
          </TabsContent>
          <TabsContent value="usuarios" className="space-y-6">
            <div className="flex flex-col md:flex-row justify-between items-start md:items-center gap-4 mb-6">
              <div>
                <h2 className="text-3xl font-black tracking-tight">
                  Gestión de <span className="text-orange-500">Usuarios</span> ({usuariosTotal})
                </h2>
                <p className="text-muted-foreground text-sm font-medium">Visualiza y gestiona los accesos de tus clientes y colaboradores.</p>
              </div>
              <div className="relative w-full md:w-80 group">
                <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground group-focus-within:text-orange-500 transition-colors" />
                <Input
                  placeholder="Buscar por nombre o email..."
                  className="pl-10 h-11 bg-card border-slate-200 focus:ring-orange-500 rounded-xl"
                  value={searchTermUsuarios}
                  onChange={(e) => {
                    const val = e.target.value;
                    setSearchTermUsuarios(val);
                    // Debounce simple: si el valor cambia rápido, el timeout se limpia
                    if (window.searchTimeout) clearTimeout(window.searchTimeout);
                    window.searchTimeout = setTimeout(() => {
                      fetchUsuarios(1, val);
                    }, 500);
                  }}
                />
              </div>
            </div>

            {loading ? (
              <div className="flex flex-col items-center justify-center py-24 gap-4">
                <div className="h-12 w-12 rounded-full border-4 border-orange-500/20 border-t-orange-500 animate-spin"></div>
                <span className="font-bold text-muted-foreground animate-pulse">Cargando usuarios...</span>
              </div>
            ) : (
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-2 gap-6">
                {usuarios.map((usuario) => {
                  const tienePendientes = usuario.boletos_pendientes_count > 0;
                  return (
                  <Card key={usuario.id} className={`group overflow-hidden shadow-xl transition-all duration-500 hover:-translate-y-1 rounded-[1.25rem] ${tienePendientes ? 'bg-orange-50 dark:bg-orange-950/30 border border-orange-500' : 'bg-card border-none hover:shadow-2xl'}`}>
                    <CardContent className="p-0 relative">
                      {tienePendientes && (
                        <div className="absolute top-0 right-0 bg-orange-500 text-white text-[10px] font-bold px-3 py-1 rounded-bl-lg shadow-md animate-pulse z-10">
                          {usuario.boletos_pendientes_count} Pendiente{usuario.boletos_pendientes_count > 1 ? 's' : ''}
                        </div>
                      )}
                      <div className="p-4">
                        {/* Bloque 1: Identidad */}
                        <div className="flex items-start justify-between mb-4 mt-2">
                          <div className="flex items-center gap-3">
                            <div className="h-12 w-12 rounded-xl bg-gradient-to-br from-orange-400 to-orange-600 flex items-center justify-center text-white text-lg font-black shadow-lg shadow-orange-500/20">
                              {usuario.name?.split(' ').map(n => n[0]).join('').substring(0, 2).toUpperCase()}
                            </div>
                            <div>
                              <div className="flex items-center gap-2">
                                <h3 className="text-xl font-black tracking-tight group-hover:text-orange-500 transition-colors">{usuario.name}</h3>
                                {usuario.bloqueado && (
                                  <Badge variant="destructive" className="rounded-full px-2 h-5 text-[10px] uppercase font-black">Bloqueado</Badge>
                                )}
                              </div>
                              <p className="text-sm font-medium text-muted-foreground">{usuario.email}</p>
                            </div>
                          </div>
                          
                          {/* Bloque 2: Estado / Rol (Badge Visual) */}
                          <Badge className={`rounded-lg px-3 py-1 text-[10px] uppercase font-black border-none shadow-none ${
                            usuario.role === 'admin' ? 'bg-red-500/10 text-red-600' :
                            usuario.role === 'vendedor' ? 'bg-orange-500/10 text-orange-600' : 
                            'bg-slate-500/10 text-slate-600'
                          }`}>
                            {usuario.role}
                          </Badge>
                        </div>

                        {/* Bloque 3: Datos en Grid */}
                        <div className="grid grid-cols-2 gap-3 p-3 bg-slate-50 dark:bg-white/5 rounded-xl border border-slate-100 dark:border-white/5 mb-4">
                          <div className="space-y-1">
                            <span className="block text-[10px] font-black uppercase text-muted-foreground tracking-widest">Cédula / ID</span>
                            <p className="text-sm font-bold flex items-center gap-2">
                              <ShieldCheck className="w-3.5 h-3.5 text-orange-500" />
                              {usuario.cedula || '---'}
                            </p>
                          </div>
                          <div className="space-y-1">
                            <span className="block text-[10px] font-black uppercase text-muted-foreground tracking-widest">Celular</span>
                            <p className="text-sm font-bold flex items-center gap-2">
                              <Phone className="w-3.5 h-3.5 text-orange-500" />
                              {usuario.celular || '---'}
                            </p>
                          </div>
                        </div>

                        {/* Bloque 4: Acciones */}
                        <div className="flex flex-wrap gap-2 pt-3 border-t border-slate-100 dark:border-white/10 mt-0">
                          <AppButton
                            variant="secondary"
                            className="flex-1 h-10 text-xs font-black rounded-xl"
                            onClick={() => {
                              setSelectedUserReset(usuario);
                              setNewPasswordReset('');
                              setPasswordReseteada(false);
                              setShowResetPasswordModal(true);
                            }}
                            icon={Key}
                          >
                            Reset Password
                          </AppButton>
                          
                          {!usuario.bloqueado ? (
                            <AppButton
                              variant="outline"
                              className="h-10 text-xs font-black rounded-xl border-slate-200"
                              onClick={() => bloquearUsuario(usuario.id)}
                              icon={ShieldOff}
                            >
                              Bloquear
                            </AppButton>
                          ) : (
                            <AppButton
                              variant="success"
                              className="h-10 text-xs font-black rounded-xl"
                              onClick={() => desbloquearUsuario(usuario.id)}
                              icon={ShieldCheck}
                            >
                              Desbloquear
                            </AppButton>
                          )}
                          
                          <AppButton
                            variant="primary"
                            className="h-10 text-xs font-black rounded-xl bg-orange-500 hover:bg-orange-600 border-none shadow-md shadow-orange-500/20"
                            onClick={() => fetchBoletosUsuario(usuario.id, usuario)}
                            icon={Ticket}
                          >
                            Ver Boletos
                          </AppButton>
                          
                          <AppButton
                            variant="danger"
                            className="h-10 px-3 rounded-xl"
                            onClick={() => eliminarUsuario(usuario.id)}
                            icon={Trash2}
                          />
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                );
              })}
              </div>
            )}

            {/* PAGINACIÓN DE USUARIOS */}
            {usuariosTotalPages > 1 && (
              <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mt-12 mb-8 bg-card p-6 rounded-[2rem] border border-slate-100 dark:border-white/5 shadow-xl">
                <div className="flex items-center gap-2">
                  <AppButton 
                    variant="ghost"
                    className="h-11 px-4 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-orange-500/10 hover:text-orange-500 transition-all border border-transparent hover:border-orange-500/20"
                    onClick={() => fetchUsuarios(usuariosPage - 1)}
                    disabled={usuariosPage <= 1}
                    icon={ChevronRight}
                    style={{ transform: 'rotate(180deg)' }}
                  >
                    Anterior
                  </AppButton>

                  <div className="flex items-center gap-1">
                    {Array.from({ length: usuariosTotalPages }, (_, i) => i + 1).map(page => {
                      // Solo mostrar páginas cercanas a la actual si hay muchas
                      if (
                        usuariosTotalPages > 7 && 
                        page !== 1 && 
                        page !== usuariosTotalPages && 
                        Math.abs(page - usuariosPage) > 1
                      ) {
                        if (page === 2 || page === usuariosTotalPages - 1) return <span key={page} className="px-1 opacity-30">...</span>;
                        return null;
                      }

                      return (
                        <button
                          key={page}
                          onClick={() => fetchUsuarios(page)}
                          className={`h-11 min-w-[2.75rem] rounded-xl font-black text-sm transition-all duration-300 ${
                            usuariosPage === page 
                              ? 'bg-orange-500 text-white shadow-lg shadow-orange-500/40 scale-110' 
                              : 'hover:bg-orange-500/10 text-muted-foreground hover:text-orange-500'
                          }`}
                        >
                          {page}
                        </button>
                      );
                    })}
                  </div>

                  <AppButton 
                    variant="ghost"
                    className="h-11 px-4 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-orange-500/10 hover:text-orange-500 transition-all border border-transparent hover:border-orange-500/20"
                    onClick={() => fetchUsuarios(usuariosPage + 1)}
                    disabled={usuariosPage >= usuariosTotalPages}
                    icon={ChevronRight}
                  >
                    Siguiente
                  </AppButton>
                </div>

                <div className="h-8 w-px bg-slate-200 dark:bg-white/10 hidden sm:block"></div>

                <div className="text-xs font-black uppercase tracking-widest text-muted-foreground opacity-60">
                  Mostrando {usuarios.length} de {usuariosTotal} usuarios
                </div>
              </div>
            )}
          </TabsContent>
          <TabsContent value="pendientes" className="space-y-6 pt-6">
            {(() => {
              // Agrupar todo antes de decidir qué mostrar
              const raffleGroups = new Map();
              boletosPendientes.forEach(b => {
                const sid = b.sorteo_id;
                if (!raffleGroups.has(sid)) {
                  const sRef = sorteos.find(s => s.id === sid);
                  raffleGroups.set(sid, {
                    id: sid,
                    titulo: sRef?.titulo || b.sorteo?.titulo || 'Sorteo Desconocido',
                    estado: sRef?.estado || b.sorteo?.estado || null,
                    boletosCount: 0,
                    solicitudesMap: new Map()
                  });
                }
                const g = raffleGroups.get(sid);
                g.boletosCount++;
                const pid = b.purchase_id || `ind_${b.id}`;
                if (!g.solicitudesMap.has(pid)) g.solicitudesMap.set(pid, []);
                g.solicitudesMap.get(pid).push(b);
              });
              
              const raffles = Array.from(raffleGroups.values());
              const totalBoletos = boletosPendientes.length;
              const totalSolicitudes = raffles.reduce((acc, r) => acc + r.solicitudesMap.size, 0);

              // 1. VISTA DE RESUMEN POR SORTEO
              if (!sorteoPendienteId) {
                return (
                  <div className="space-y-6">
                    <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
                      <div>
                        <h2 className="text-3xl font-black tracking-tight text-foreground">Boletos Pendientes</h2>
                        <p className="text-muted-foreground text-sm font-medium">Gestiona las aprobaciones agrupadas por sorteo.</p>
                      </div>
                      <div className="flex gap-2">
                        <div className="px-4 py-2 bg-primary/10 border border-primary/20 rounded-2xl flex flex-col items-center">
                          <span className="text-xs font-bold text-primary uppercase">Boletos</span>
                          <span className="text-xl font-black">{totalBoletos}</span>
                        </div>
                        <div className="px-4 py-2 bg-orange-500/10 border border-orange-500/20 rounded-2xl flex flex-col items-center">
                          <span className="text-xs font-bold text-orange-500 uppercase">Solicitudes</span>
                          <span className="text-xl font-black">{totalSolicitudes}</span>
                        </div>
                      </div>
                    </header>

                    {loadingPendientes ? (
                      <div className="flex flex-col items-center justify-center py-24 gap-4">
                        <div className="relative">
                          <div className="h-16 w-16 rounded-full border-4 border-primary/20 border-t-primary animate-spin"></div>
                          <Clock className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 text-primary" />
                        </div>
                        <span className="font-bold text-muted-foreground animate-pulse">Cargando solicitudes...</span>
                      </div>
                    ) : raffles.length === 0 ? (
                      <Card className="p-16 border-dashed bg-slate-50/50 dark:bg-white/5 flex flex-col items-center text-center gap-4">
                        <div className="w-20 h-20 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center">
                          <ShieldCheck className="w-10 h-10 text-muted-foreground opacity-30" />
                        </div>
                        <div>
                          <h3 className="text-xl font-bold">Todo al día</h3>
                          <p className="text-muted-foreground max-w-xs mx-auto">No hay boletos esperando aprobación en este momento.</p>
                        </div>
                      </Card>
                    ) : (
                      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                        {raffles.map(raffle => (
                          <Card key={raffle.id} className="group overflow-hidden border-none shadow-xl bg-card hover:shadow-2xl transition-all duration-500 hover:-translate-y-1">
                            <div className="p-6 space-y-4">
                              <div className="flex justify-between items-start gap-3">
                                <div className="space-y-1">
                                    <Badge className="bg-primary/10 text-primary border-none text-[10px] uppercase font-black px-2 shadow-none">
                                      {raffle.estado || 'ACTIVO'}
                                    </Badge>
                                  <h3 className="font-black text-xl leading-tight group-hover:text-primary transition-colors line-clamp-2">
                                    {raffle.titulo}
                                  </h3>
                                </div>
                                <div className="p-3 bg-slate-50 dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                                  <ChevronRight className="w-5 h-5 text-muted-foreground group-hover:text-primary group-hover:translate-x-1 transition-all" />
                                </div>
                              </div>

                              <div className="grid grid-cols-2 gap-3">
                                <div className="p-3 bg-slate-50 dark:bg-white/5 rounded-xl border border-slate-100 dark:border-white/5">
                                  <span className="block text-[10px] font-black uppercase text-muted-foreground mb-1">Boletos</span>
                                  <span className="text-xl font-black text-primary">{raffle.boletosCount}</span>
                                </div>
                                <div className="p-3 bg-slate-50 dark:bg-white/5 rounded-xl border border-slate-100 dark:border-white/5">
                                  <span className="block text-[10px] font-black uppercase text-muted-foreground mb-1">Solicitudes</span>
                                  <span className="text-xl font-black text-orange-500">{raffle.solicitudesMap.size}</span>
                                </div>
                              </div>

                              <AppButton 
                                variant="primary" 
                                className="w-full h-12 rounded-xl text-lg font-black"
                                onClick={() => setSorteoPendienteId(raffle.id)}
                                icon={Activity}
                              >
                                Ver boletos pendientes
                              </AppButton>
                            </div>
                          </Card>
                        ))}
                      </div>
                    )}
                  </div>
                );
              }

              // 2. VISTA DE DETALLE FILTRADA
              const activeRaffle = raffleGroups.get(sorteoPendienteId);
              if (!activeRaffle) {
                setSorteoPendienteId(null);
                return null;
              }

              const solicitudes = Array.from(activeRaffle.solicitudesMap.values());

              return (
                <div className="space-y-6 animate-in fade-in slide-in-from-right-4 duration-500">
                  <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-6 pb-6 border-b border-slate-100 dark:border-white/5">
                    <div className="flex items-center gap-4">
                      <Button 
                        variant="ghost" 
                        size="icon" 
                        className="h-12 w-12 rounded-2xl bg-slate-100 dark:bg-white/5 hover:bg-primary/10 hover:text-primary transition-all"
                        onClick={() => setSorteoPendienteId(null)}
                      >
                        <ChevronRight className="w-6 h-6 rotate-180" />
                      </Button>
                      <div>
                        <h2 className="text-3xl font-black tracking-tight">{activeRaffle.titulo}</h2>
                        <div className="flex items-center gap-2 text-sm font-bold text-muted-foreground">
                          <Badge variant="outline" className="text-orange-500 border-orange-500/20 bg-orange-500/5">PENDIENTES</Badge>
                          <span>•</span>
                          <span>{solicitudes.length} solicitudes de aprobación</span>
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center gap-3">
                      <Badge className="h-10 px-4 flex items-center gap-2 rounded-xl bg-orange-500/10 text-orange-500 border border-orange-500/20 text-sm font-black shadow-none">
                        <Users className="w-4 h-4" />
                        {activeRaffle.boletosCount} boletos esperando
                      </Badge>
                    </div>
                  </header>

                  <div className="grid gap-6">
                    {solicitudes.map(group => {
                      const sample = group[0];
                      const totalMonto = group.reduce((acc, b) => acc + (b.precio_pagado || 0), 0);
                      const displayTitle = group.length > 1 ? `Compra de ${group.length} boletos grupo` : `Compra de 1 boleto`;

                      return (
                        <Card key={sample.purchase_id || sample.id} className="group border-none shadow-xl bg-card overflow-hidden transition-all duration-300 hover:shadow-2xl">
                          <div className="p-6 md:p-8 flex flex-col lg:flex-row gap-8">
                            {/* Columna 1: Info e Identidad */}
                            <div className="flex-1 space-y-6">
                              <div className="flex items-center justify-between">
                                <div className="flex items-center gap-3">
                                  <div className="h-12 w-12 rounded-2xl bg-orange-500/10 flex items-center justify-center">
                                    <Banknote className="w-6 h-6 text-orange-500" />
                                  </div>
                                  <div>
                                    <h4 className="text-xl font-black tracking-tight">{displayTitle}</h4>
                                    <span className="text-xs font-bold text-muted-foreground uppercase opacity-70">
                                      {formatDateTime(sample.fecha_compra)}
                                    </span>
                                  </div>
                                </div>
                                <Badge className="bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border border-yellow-500/20 uppercase font-black text-[10px] h-6 px-2 shadow-none">
                                  Pendiente
                                </Badge>
                              </div>

                              <div className="space-y-3">
                                <Label className="text-xs font-black uppercase text-muted-foreground tracking-widest">Boletos Reservados</Label>
                                <div className="flex flex-wrap gap-2">
                                  {group.map(b => (
                                    <span key={b.id} className="h-9 px-4 rounded-xl bg-slate-100 dark:bg-white/10 text-foreground font-black text-sm flex items-center justify-center border border-slate-200 dark:border-white/10 hover:border-primary/50 transition-colors">
                                      #{b.numero_boleto.toString().padStart(4, '0')}
                                    </span>
                                  ))}
                                </div>
                              </div>

                              <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 p-5 bg-slate-50 dark:bg-white/5 rounded-3xl border border-slate-100 dark:border-white/5">
                                <div className="space-y-1">
                                  <span className="text-[10px] font-black uppercase text-muted-foreground tracking-widest block">Usuario / Cliente</span>
                                  <p className="font-bold text-foreground text-sm truncate">{sample.usuario?.nombre || '---'}</p>
                                  <p className="text-xs text-muted-foreground truncate">{sample.usuario?.email}</p>
                                </div>
                                <div className="space-y-1">
                                  <span className="text-[10px] font-black uppercase text-muted-foreground tracking-widest block">Documentación</span>
                                  <p className="text-xs font-bold text-foreground truncate flex items-center gap-2">
                                    <ShieldCheck className="w-3 h-3 text-primary" /> {sample.usuario?.cedula || 'Sin Cédula'}
                                  </p>
                                  <p className="text-xs font-bold text-foreground truncate flex items-center gap-2">
                                    <Phone className="w-3 h-3 text-primary" /> {sample.usuario?.celular || '---'}
                                  </p>
                                </div>
                              </div>
                            </div>

                            {/* Columna 2: Finanzas y Acciones */}
                            <div className="lg:w-80 flex flex-col justify-between border-t lg:border-t-0 lg:border-l border-slate-100 dark:border-white/5 lg:pl-8 pt-6 lg:pt-0">
                              <div className="space-y-4 mb-8">
                                <div className="flex flex-col items-center lg:items-end">
                                  <span className="text-[10px] font-black uppercase text-muted-foreground tracking-widest mb-1">Monto a Cobrar</span>
                                  <span className="text-4xl font-black text-primary drop-shadow-sm">
                                    {formatCurrency(totalMonto)}
                                  </span>
                                  <span className="text-[10px] font-bold text-muted-foreground mt-1 bg-slate-100 dark:bg-white/10 px-2 py-0.5 rounded-full">
                                    ({formatCurrency(sample.precio_pagado)} × {group.length})
                                  </span>
                                </div>
                                
                                <div className="p-4 bg-primary/5 rounded-2xl border border-primary/10 text-center">
                                  <p className="text-[10px] font-bold text-primary flex items-center justify-center gap-1">
                                    <Sparkles className="w-3 h-3" /> Al aprobar se activarán los {group.length} boletos
                                  </p>
                                </div>
                              </div>

                              <div className="space-y-3">
                                {/* Botón WhatsApp ANTES de aprobar: aviso de recepción */}
                                <a
                                  href={buildWAUrl(
                                    sample.usuario?.celular,
                                    waAvisoRevision({
                                      nombresorteo: activeRaffle.titulo,
                                      cliente: sample.usuario,
                                      numeros_boletos: group.map(b => b.numero_boleto),
                                      totalMonto,
                                    })
                                  )}
                                  target="_blank"
                                  rel="noopener noreferrer"
                                >
                                  <AppButton
                                    variant="secondary"
                                    className="w-full h-10 rounded-xl font-black text-xs border-green-500/30 text-green-600 dark:text-green-400 bg-green-500/5 hover:bg-green-500 hover:text-white"
                                    icon={MessageSquare}
                                  >
                                    WhatsApp: Avisar recepción
                                  </AppButton>
                                </a>
                                <AppButton 
                                  variant="success" 
                                  className="w-full h-12 rounded-xl font-black text-sm shadow-lg shadow-green-500/20"
                                  onClick={() => {
                                    setBoletoAprobar(sample.id);
                                    setDialogAprobarOpen(true);
                                  }}
                                  icon={CheckCircle}
                                >
                                  Aprobar {group.length} Boletos
                                </AppButton>
                                <AppButton 
                                  variant="danger" 
                                  className="w-full h-12 rounded-xl font-black text-sm shadow-lg shadow-red-500/20"
                                  onClick={() => handleRechazarBoleto(sample.id, { usuario: sample.usuario, group })}
                                  icon={XCircle}
                                >
                                  Rechazar {group.length} Boletos
                                </AppButton>
                              </div>
                            </div>
                          </div>
                        </Card>
                    );
                  })}
                </div>
              </div>
            );
            })()}
            
            {/* Controles de paginación de boletos pendientes */}
            {pendientesTotalPages > 1 && (
              <div className="flex justify-between items-center bg-slate-50 dark:bg-white/5 p-4 rounded-2xl border border-slate-100 dark:border-white/5 mt-8">
                <AppButton
                  variant="ghost"
                  className="h-11 px-4 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-orange-500/10 hover:text-orange-500 transition-all border border-transparent hover:border-orange-500/20"
                  onClick={() => fetchBoletosPendientes(pendientesPage - 1)}
                  disabled={pendientesPage === 1}
                  icon={ChevronLeft}
                >
                  Anterior
                </AppButton>

                <div className="text-xs font-black uppercase tracking-widest text-muted-foreground opacity-60">
                  Página {pendientesPage} de {pendientesTotalPages}
                </div>

                <AppButton
                  variant="ghost"
                  className="h-11 px-4 rounded-xl font-black text-xs uppercase tracking-widest hover:bg-orange-500/10 hover:text-orange-500 transition-all border border-transparent hover:border-orange-500/20"
                  onClick={() => fetchBoletosPendientes(pendientesPage + 1)}
                  disabled={pendientesPage >= pendientesTotalPages}
                >
                  Siguiente
                </AppButton>
              </div>
            )}
          </TabsContent>

        <TabsContent value="aprobados" className="space-y-8 pt-6">
            <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4">
              <div>
                <h2 className="text-3xl font-black tracking-tight text-foreground flex items-center gap-3">
                  <ShieldCheck className="w-8 h-8 text-green-500" /> 
                  Boletos <span className="text-green-500">Aprobados</span>
                </h2>
                <p className="text-muted-foreground text-sm font-medium">Historial completo de participaciones confirmadas.</p>
              </div>
              <div className="flex gap-2">
                <div className="px-6 py-3 bg-green-500/10 border border-green-500/20 rounded-2xl flex flex-col items-center shadow-lg shadow-green-500/5">
                  <span className="text-[10px] font-black text-green-600 dark:text-green-400 uppercase tracking-widest">Total Aprobados</span>
                  <span className="text-2xl font-black">{aprobadosTotal}</span>
                </div>
              </div>
            </header>
            
            <Card className="border-none shadow-2xl bg-card/50 backdrop-blur-xl overflow-hidden rounded-xl">
              <CardContent className="p-6 md:p-8">
                <div className="grid grid-cols-1 md:grid-cols-12 gap-6 items-end">
                  <div className="md:col-span-5 space-y-2">
                    <Label className="text-[10px] font-black uppercase text-muted-foreground tracking-widest ml-1">Filtrar por Sorteo</Label>
                    <Select value={sorteoFiltroAprobados} onValueChange={(value) => {
                      setSorteoFiltroAprobados(value);
                      fetchBoletosAprobados(value, numeroBoletoFiltro, 1);
                    }}>
                      <SelectTrigger className="h-14 rounded-xl bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 font-bold focus:ring-green-500/20 transition-all">
                        <SelectValue placeholder="Seleccionar un sorteo..." />
                      </SelectTrigger>
                      <SelectContent className="rounded-xl border-white/10">
                        {sorteos.map(sorteo => (
                          <SelectItem key={sorteo.id} value={sorteo.id}>{sorteo.titulo}</SelectItem>
                        ))}
                      </SelectContent>
                    </Select>
                  </div>
                  
                  <div className="md:col-span-5 space-y-2">
                    <Label className="text-[10px] font-black uppercase text-muted-foreground tracking-widest ml-1">Número de Boleto</Label>
                    <div className="relative group">
                      <Input
                        type="number"
                        placeholder="Buscar por número..."
                        value={numeroBoletoFiltro}
                        onChange={(e) => {
                           setNumeroBoletoFiltro(e.target.value);
                           // Opcional: buscar automáticamente mientras escribe si tiene 3+ caracteres
                           if (e.target.value.length >= 2 || e.target.value === '') {
                             fetchBoletosAprobados(sorteoFiltroAprobados, e.target.value, 1);
                           }
                        }}
                        onKeyDown={(e) => e.key === 'Enter' && fetchBoletosAprobados(sorteoFiltroAprobados, numeroBoletoFiltro, 1)}
                        className="h-14 pl-12 rounded-xl bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 font-bold focus:ring-green-500/20 transition-all"
                      />
                      <Search className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5 text-muted-foreground group-focus-within:text-green-500 transition-colors" />
                    </div>
                  </div>

                  <div className="md:col-span-2">
                    <AppButton 
                      variant="primary" 
                      className="w-full h-14 rounded-xl"
                      onClick={() => fetchBoletosAprobados(sorteoFiltroAprobados, numeroBoletoFiltro, 1)}
                    >
                      Buscar
                    </AppButton>
                  </div>
                </div>
              </CardContent>
            </Card>
            
            {loadingAprobados ? (
              <div className="flex flex-col items-center justify-center py-24 gap-4">
                <div className="relative">
                  <div className="h-16 w-16 rounded-full border-4 border-green-500/20 border-t-green-500 animate-spin"></div>
                  <ShieldCheck className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-6 h-6 text-green-500" />
                </div>
                <span className="font-bold text-muted-foreground animate-pulse">Cargando historial...</span>
              </div>
            ) : boletosAprobados.length === 0 ? (
              <Card className="p-20 border-dashed bg-slate-50/50 dark:bg-white/5 flex flex-col items-center text-center gap-4 rounded-xl">
                <div className="w-24 h-24 rounded-full bg-slate-100 dark:bg-white/5 flex items-center justify-center">
                  <Mail className="w-12 h-12 text-muted-foreground opacity-20" />
                </div>
                <div>
                  <h3 className="text-2xl font-black uppercase tracking-tighter">Sin resultados</h3>
                  <p className="text-muted-foreground max-w-xs mx-auto font-medium">No se encontraron boletos aprobados con estos criterios de búsqueda.</p>
                </div>
              </Card>
            ) : (
              <div className="animate-in fade-in slide-in-from-bottom-4 duration-700">
                <div className="grid gap-6">
                  {boletosAprobados.map((boleto) => (
                    <Card key={boleto.id} className="group overflow-hidden border-none shadow-xl bg-card hover:shadow-2xl transition-all duration-300 hover:-translate-y-1 rounded-xl">
                      <div className="flex flex-col lg:flex-row">
                        {/* Identificador Lateral */}
                        <div className="lg:w-48 bg-gradient-to-br from-green-500 to-green-700 flex flex-col items-center justify-center p-6 text-white relative">
                          <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/carbon-fibre.png')] opacity-10" />
                          <div className="relative z-10 w-14 h-14 bg-white/20 backdrop-blur-md rounded-2xl flex items-center justify-center mb-3 border border-white/20">
                             <Ticket className="w-7 h-7 text-white" />
                          </div>
                          <div className="relative z-10 text-center">
                             <p className="text-[10px] font-black text-white/70 uppercase tracking-[0.2em] mb-1">NÚMERO</p>
                             <h5 className="text-3xl font-black text-white tracking-tighter">
                                #{boleto.numero_boleto.toString().padStart(4, '0')}
                             </h5>
                          </div>
                        </div>

                        {/* Contenido Principal */}
                        <div className="flex-1 p-6 md:p-8 grid md:grid-cols-2 lg:grid-cols-3 gap-8">
                          {/* Sorteo y Estado */}
                          <div className="space-y-4">
                            <div className="flex items-center gap-2">
                               <Badge className="bg-green-500/10 text-green-600 dark:text-green-400 border-none font-black text-[10px] tracking-widest uppercase px-3 shadow-none">
                                 APROBADO
                               </Badge>
                               <span className="text-[10px] font-black text-muted-foreground uppercase opacity-50">•</span>
                               <span className="text-[10px] font-black text-muted-foreground uppercase tracking-widest">{formatDate(boleto.fecha_compra)}</span>
                            </div>
                            <div>
                               <p className="text-[10px] font-black text-muted-foreground uppercase tracking-widest mb-1.5 flex items-center gap-1.5">
                                 <Trophy className="w-3 h-3" /> Evento
                               </p>
                               <h4 className="font-black text-xl text-foreground leading-tight line-clamp-2 italic uppercase tracking-tighter">
                                 {boleto.sorteo?.titulo}
                               </h4>
                               <p className="text-[10px] font-bold text-muted-foreground mt-1 opacity-60">ID: {boleto.sorteo?.landing_slug}</p>
                            </div>
                          </div>

                          {/* Usuario e info técnica */}
                          <div className="space-y-4 md:border-l md:pl-8 border-slate-100 dark:border-white/5">
                            <div>
                               <p className="text-[10px] font-black text-muted-foreground uppercase tracking-widest mb-3 flex items-center gap-1.5">
                                 <User className="w-3 h-3" /> Adquirido Por
                               </p>
                               <div className="flex items-center gap-3">
                                  <div className="w-10 h-10 rounded-xl bg-slate-100 dark:bg-white/5 flex items-center justify-center font-black text-primary border border-slate-200 dark:border-white/10">
                                    {boleto.usuario?.name?.[0]?.toUpperCase() || 'U'}
                                  </div>
                                  <div className="overflow-hidden">
                                     <p className="font-black text-sm text-foreground truncate">{boleto.usuario?.name || '---'}</p>
                                     <p className="text-[10px] text-muted-foreground truncate opacity-70 italic">{boleto.usuario?.email}</p>
                                  </div>
                               </div>
                            </div>
                            <div className="pt-2 bg-slate-50 dark:bg-white/5 rounded-2xl p-3 border border-slate-100 dark:border-white/5">
                               <p className="text-[9px] font-black text-slate-500 uppercase tracking-widest mb-1">Comprobante:</p>
                               <p className="text-sm font-black text-green-600 font-mono tracking-wider truncate">{boleto.numero_comprobante || 'PROCESADO'}</p>
                            </div>
                          </div>

                          {/* Finanzas y CTA */}
                          <div className="lg:border-l lg:pl-8 border-slate-100 dark:border-white/5 flex flex-col justify-center text-center lg:text-right">
                             <p className="text-[10px] font-black text-muted-foreground uppercase tracking-widest mb-1">Inversión del Usuario</p>
                             <div className="relative inline-block lg:ml-auto">
                                <span className="text-4xl font-black text-foreground drop-shadow-sm tracking-tighter">
                                  {formatCurrency(boleto.precio_pagado)}
                                </span>
                                <div className="absolute -top-3 -right-3">
                                   <div className="w-6 h-6 bg-green-500/10 rounded-full flex items-center justify-center animate-pulse">
                                      < DollarSign className="w-3 h-3 text-green-500" />
                                   </div>
                                </div>
                             </div>
                             <div className="mt-4 pt-4 border-t border-slate-100 dark:border-white/5">
                                <span className="text-[9px] font-black text-muted-foreground uppercase tracking-[0.2em] opacity-40 italic">
                                  Verificado el {formatDateTime(boleto.fecha_compra)}
                                </span>
                             </div>
                          </div>
                        </div>
                      </div>
                    </Card>
                  ))}
                </div>

                {/* PAGINACIÓN DE APROBADOS */}
                {aprobadosTotalPages > 1 && (
                  <div className="flex flex-col sm:flex-row justify-center items-center gap-6 mt-12 mb-8 bg-card p-6 rounded-xl border border-slate-100 dark:border-white/5 shadow-2xl">
                    <div className="flex items-center gap-2">
                      <AppButton 
                        variant="ghost"
                        className="h-12 px-6 rounded-xl font-black text-xs uppercase tracking-[0.2em] hover:bg-green-500/10 hover:text-green-500 transition-all border border-transparent hover:border-green-500/20"
                        onClick={() => fetchBoletosAprobados(sorteoFiltroAprobados, numeroBoletoFiltro, aprobadosPage - 1)}
                        disabled={aprobadosPage <= 1}
                        icon={ChevronRight}
                        style={{ transform: 'rotate(180deg)' }}
                      >
                        Anterior
                      </AppButton>

                      <div className="flex items-center gap-2">
                        {Array.from({ length: aprobadosTotalPages }, (_, i) => i + 1).map(page => {
                          if (
                            aprobadosTotalPages > 7 && 
                            page !== 1 && 
                            page !== aprobadosTotalPages && 
                            Math.abs(page - aprobadosPage) > 1
                          ) {
                            if (page === 2 || page === aprobadosTotalPages - 1) return <span key={page} className="px-2 opacity-30 text-lg font-black">...</span>;
                            return null;
                          }

                          return (
                            <button
                              key={page}
                              onClick={() => fetchBoletosAprobados(sorteoFiltroAprobados, numeroBoletoFiltro, page)}
                              className={`h-12 min-w-[3rem] rounded-xl font-black text-sm transition-all duration-500 ${
                                aprobadosPage === page 
                                  ? 'bg-green-600 text-white shadow-xl shadow-green-600/30 scale-110' 
                                  : 'hover:bg-green-600/10 text-muted-foreground hover:text-green-600'
                              }`}
                            >
                              {page}
                            </button>
                          );
                        })}
                      </div>

                      <AppButton 
                        variant="ghost"
                        className="h-12 px-6 rounded-2xl font-black text-xs uppercase tracking-[0.2em] hover:bg-green-500/10 hover:text-green-600 transition-all border border-transparent hover:border-green-500/20"
                        onClick={() => fetchBoletosAprobados(sorteoFiltroAprobados, numeroBoletoFiltro, aprobadosPage + 1)}
                        disabled={aprobadosPage >= aprobadosTotalPages}
                        icon={ChevronRight}
                      >
                        Siguiente
                      </AppButton>
                    </div>

                    <div className="h-10 w-px bg-slate-200 dark:bg-white/10 hidden sm:block"></div>

                    <div className="text-[10px] font-black uppercase tracking-[0.2em] text-muted-foreground opacity-60">
                      Viendo {boletosAprobados.length} de {aprobadosTotal} boletos
                    </div>
                  </div>
                )}
              </div>
            )}
          </TabsContent>

          {/* TAB DE RETIROS */}
          <TabsContent value="retiros" className="space-y-4">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-2xl font-bold">Retiros de Vendedores</h2>
              <AppButton onClick={fetchRetiros} variant="secondary" size="sm" icon={RefreshCcw}>
                Actualizar
              </AppButton>
            </div>
            
            {loadingRetiros ? (
              <div className="text-center py-12">
                <div className="inline-block animate-spin rounded-full h-12 w-12 border-b-2 border-primary"></div>
              </div>
            ) : retiros.length === 0 ? (
              <Card className="p-12 text-center">
                <p className="text-gray-600">No hay retiros pendientes</p>
              </Card>
            ) : (
              <div className="grid gap-4">
                {retiros.map((retiro) => (
                  <Card key={retiro.id} className="sorteo-card">
                    <CardContent className="p-6">
                      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
                        <div className="lg:col-span-2">
                          <div className="flex items-center gap-2 mb-3">
                            <Badge className={
                              retiro.estado === 'pendiente' ? 'bg-yellow-100 text-yellow-700' :
                              retiro.estado === 'aprobado' ? 'bg-green-100 text-green-700' :
                              'bg-red-100 text-red-700'
                            }>
                              {retiro.estado.toUpperCase()}
                            </Badge>
                          </div>
                          
                          <div className="space-y-2">
                            <div>
                              <span className="text-sm font-semibold">Vendedor:</span>
                              <p className="text-gray-700">{retiro.vendedor?.name}</p>
                              <p className="text-xs text-gray-500">{retiro.vendedor?.email}</p>
                            </div>
                            
                            <div>
                              <span className="text-sm font-semibold">Monto solicitado:</span>
                              <p className="text-2xl font-bold text-green-600">{formatCurrency(retiro.monto)}</p>
                            </div>
                            
                            <div>
                              <span className="text-sm font-semibold">Fecha de solicitud:</span>
                              <p className="text-gray-700">{formatDateTime(retiro.fecha_solicitud)}</p>
                            </div>
                            
                            <div className="border-t pt-2 mt-2">
                              <span className="text-sm font-semibold block mb-1">Datos Bancarios:</span>
                              <div className="bg-gray-50 p-3 rounded text-sm space-y-1">
                                <p><strong>Banco:</strong> {retiro.vendedor?.nombre_banco || 'No especificado'}</p>
                                <p><strong>Tipo:</strong> {retiro.vendedor?.tipo_cuenta || 'No especificado'}</p>
                                <p><strong>Cuenta:</strong> {retiro.vendedor?.numero_cuenta || 'No especificado'}</p>
                                <p><strong>Teléfono:</strong> {retiro.vendedor?.telefono || 'No especificado'}</p>
                                {retiro.vendedor?.whatsapp && retiro.vendedor.whatsapp !== retiro.vendedor.telefono && (
                                  <p><strong>WhatsApp:</strong> {retiro.vendedor.whatsapp}</p>
                                )}
                              </div>
                            </div>
                            
                            {retiro.comprobante_url && (
                              <div>
                                <span className="text-sm font-semibold">Comprobante:</span>
                                <a href={retiro.comprobante_url} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline block">
                                  Ver comprobante
                                </a>
                              </div>
                            )}
                            
                            {retiro.motivo_rechazo && (
                              <div>
                                <span className="text-sm font-semibold">Motivo de rechazo:</span>
                                <p className="text-red-600">{retiro.motivo_rechazo}</p>
                              </div>
                            )}
                          </div>
                        </div>
                        
                        <div className="flex flex-col gap-2">
                          {retiro.estado === 'pendiente' && (
                            <>
                              <AppButton 
                                variant="success"
                                onClick={() => {
                                  setRetiroSeleccionado(retiro);
                                  setShowAprobarRetiro(true);
                                }}
                                icon={CheckCircle}
                              >
                                Aprobar
                              </AppButton>
                              
                              <AppButton 
                                variant="danger"
                                onClick={() => handleRechazarRetiro(retiro.id)}
                                icon={XCircle}
                              >
                                Rechazar
                              </AppButton>
                            </>
                          )}
                        </div>
                      </div>
                    </CardContent>
                  </Card>
                ))}
              </div>
            )}
          </TabsContent>

          <TabsContent value="hero" className="space-y-6">
            <Card className="border-slate-200 dark:border-white/10 bg-white dark:bg-slate-900/50 backdrop-blur-xl">
              <CardHeader className="border-b border-slate-100 dark:border-white/5 p-4 sm:p-6">
                <div className="flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
                  <div>
                    <CardTitle className="text-xl sm:text-2xl font-black text-slate-900 dark:text-white flex items-center gap-3">
                      <Layout className="w-6 h-6 text-orange-500" /> Configuración Hero Principal
                    </CardTitle>
                    <p className="text-xs sm:text-sm text-slate-500 dark:text-white/50 mt-1">Personaliza el mensaje y el fondo de la página de inicio.</p>
                  </div>
                  <AppButton 
                    onClick={handleSaveHero} 
                    loading={isSavingHero}
                    icon={Save}
                    className="w-full sm:w-auto bg-orange-600 hover:bg-orange-500 order-first sm:order-none"
                  >
                    Guardar Cambios
                  </AppButton>
                </div>
              </CardHeader>
              <CardContent className="p-4 sm:p-8">
                <div className="max-w-xl">
                  <div className="space-y-6">
                    <div className="space-y-4">
                      <h3 className="text-lg font-bold text-slate-900 dark:text-white flex items-center gap-2">
                         <Layout className="w-5 h-5 text-orange-500" /> Indicador de Progreso
                      </h3>
                      <div className="space-y-2 text-white">
                        <Label className="text-slate-600 dark:text-white/70 font-bold uppercase text-[10px] tracking-widest">
                          Porcentaje Vendido ({Math.round(heroConfig.progreso_falso || 35)}%)
                        </Label>
                        <input 
                          type="range"
                          min="0"
                          max="100"
                          step="1"
                          value={heroConfig.progreso_falso || 35}
                          onChange={(e) => setHeroConfig({...heroConfig, progreso_falso: parseFloat(e.target.value)})}
                          className="w-full h-2 bg-slate-200 dark:bg-white/10 rounded-lg appearance-none cursor-pointer accent-orange-500"
                        />
                        <p className="text-[10px] text-slate-500 dark:text-slate-400 mt-2">
                          Este valor falso modificará visualmente la barra superior y otros indicadores en el Home.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="payphone" className="space-y-6 pt-6">
            <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-2">
              <div>
                <h2 className="text-3xl font-black tracking-tight text-foreground flex items-center gap-3">
                  <CreditCard className="w-8 h-8 text-orange-500" /> 
                  Pasarela de <span className="text-orange-500">Pagos</span>
                </h2>
                <p className="text-muted-foreground text-sm font-medium">Configura la integración con PayPhone para aceptar tarjetas.</p>
              </div>
              <AppButton 
                onClick={handleSavePayphone} 
                loading={isSavingPayphone}
                icon={Save}
                className="bg-orange-600 hover:bg-orange-500 shadow-lg shadow-orange-600/20 px-8 h-12 rounded-xl font-black uppercase text-xs tracking-widest"
              >
                Guardar Configuración
              </AppButton>
            </header>

            {/* Diagnóstico de PayPhone */}
            <Card className="border-none shadow-xl bg-card overflow-hidden mb-4">
              <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                    <Activity className="w-4 h-4" /> Diagnóstico de Conexión
                  </CardTitle>
                  <AppButton
                    onClick={handleRunPayphoneDiagnostics}
                    loading={isRunningPayphoneDiag}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 h-9 rounded-lg font-black uppercase text-[10px] tracking-widest"
                    data-testid="run-payphone-diagnostics-btn"
                  >
                    Ejecutar Diagnóstico
                  </AppButton>
                </div>
              </CardHeader>
              <CardContent className="pt-4">
                {!payphoneDiagnostics ? (
                  <p className="text-xs text-muted-foreground italic">
                    Ejecuta el diagnóstico para verificar token, store ID y conectividad con la API de PayPhone Cajita de Pagos v2.0.
                  </p>
                ) : (
                  <div className="space-y-2 text-xs font-mono" data-testid="payphone-diagnostics-result">
                    <div className={`p-3 rounded-lg ${payphoneDiagnostics.ok ? 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-800 dark:text-emerald-200' : 'bg-red-50 dark:bg-red-950/30 text-red-800 dark:text-red-200'}`}>
                      <p className="font-bold mb-2">
                        {payphoneDiagnostics.ok ? '✅ Conexión OK' : '❌ Problema detectado'}
                      </p>
                      {payphoneDiagnostics.endpoint && <p className="break-all">API: {payphoneDiagnostics.endpoint}</p>}
                      {payphoneDiagnostics.token_preview && <p>Token: {payphoneDiagnostics.token_preview}</p>}
                      {payphoneDiagnostics.store_id_preview && <p>Store ID: {payphoneDiagnostics.store_id_preview}</p>}
                      {payphoneDiagnostics.http_status !== undefined && <p>HTTP: {payphoneDiagnostics.http_status}</p>}
                      {payphoneDiagnostics.auth_ok !== undefined && (
                        <p>Auth: {payphoneDiagnostics.auth_ok ? '✅ Token válido' : '❌ Token inválido'}</p>
                      )}
                      {payphoneDiagnostics.error && (
                        <p className="mt-2 break-words"><strong>Error:</strong> {payphoneDiagnostics.error}</p>
                      )}
                      {payphoneDiagnostics.hint && (
                        <p className="mt-2 break-words p-2 bg-amber-100 dark:bg-amber-950/50 rounded text-amber-900 dark:text-amber-200">
                          💡 {payphoneDiagnostics.hint}
                        </p>
                      )}
                      {payphoneDiagnostics.message && (
                        <p className="mt-2 font-bold">{payphoneDiagnostics.message}</p>
                      )}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Columna 1: Estado y Recargo */}
              <div className="space-y-6">
                <Card className="border-none shadow-xl bg-card overflow-hidden">
                  <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                    <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                      <Activity className="w-4 h-4" /> Estado del Servicio
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-6 space-y-6">
                    <div className="flex items-center justify-between p-4 bg-slate-50 dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                      <div className="space-y-0.5">
                        <span className="text-sm font-bold block">Pasarela PayPhone</span>
                        <span className="text-[10px] text-muted-foreground uppercase font-black tracking-wider">
                          {payphoneConfig.activo ? 'Operativa' : 'Desactivada'}
                        </span>
                      </div>
                      <button 
                        type="button"
                        onClick={() => setPayphoneConfig({...payphoneConfig, activo: !payphoneConfig.activo})}
                        className={`w-14 h-7 rounded-full transition-all duration-500 relative ${payphoneConfig.activo ? 'bg-orange-500 shadow-inner' : 'bg-slate-300 dark:bg-white/10'}`}
                      >
                        <div className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-lg transition-all duration-500 ${payphoneConfig.activo ? 'left-8' : 'left-1'}`} />
                      </button>
                    </div>

                    <div className="space-y-3 p-4 bg-orange-500/5 rounded-2xl border border-orange-500/10">
                      <Label className="text-[10px] font-black uppercase tracking-widest text-orange-600 dark:text-orange-400">Recargo por Tarjeta (%)</Label>
                      <div className="flex items-center gap-4">
                        <Input 
                          type="number" 
                          step="0.01"
                          value={payphoneConfig.porcentaje_adicional}
                          onChange={(e) => setPayphoneConfig({...payphoneConfig, porcentaje_adicional: parseFloat(e.target.value) || 0})}
                          className="h-12 text-xl font-black bg-white dark:bg-slate-900 border-orange-500/20 text-center rounded-xl focus:ring-orange-500"
                        />
                        <div className="text-[10px] text-muted-foreground font-medium uppercase leading-tight">
                          Este porcentaje se sumará al total solo en pagos con tarjeta.
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <div className="p-6 bg-slate-100 dark:bg-white/5 rounded-3xl border border-dashed border-slate-200 dark:border-white/10 flex gap-4">
                  <AlertCircle className="w-6 h-6 text-orange-500 shrink-0" />
                  <p className="text-[10px] text-muted-foreground font-medium leading-relaxed uppercase tracking-wider">
                    Asegúrate de que el token esté correctamente configurado para evitar fallos en la confirmación de las transacciones. El sistema valida el pago antes de liberar los boletos.
                  </p>
                </div>
              </div>

              {/* Columna 2 y 3: Credenciales API */}
              <div className="lg:col-span-2">
                <Card className="border-none shadow-xl bg-card h-full">
                  <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                    <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                      <ShieldCheck className="w-4 h-4" /> Credenciales de Integración
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-8 space-y-8">
                    <div className="grid grid-cols-1 gap-8">
                      <div className="space-y-3">
                        <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Store ID (Comercio)</Label>
                        <Input 
                          placeholder="Tu Store ID de PayPhone"
                          value={payphoneConfig.store_id}
                          onChange={(e) => setPayphoneConfig({...payphoneConfig, store_id: e.target.value})}
                          className="h-14 bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 rounded-2xl font-bold text-lg px-6 focus:border-orange-500/50"
                        />
                        <p className="text-[10px] text-muted-foreground italic ml-2">Identificador único asignado por PayPhone a su establecimiento.</p>
                      </div>

                      <div className="space-y-3">
                        <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-orange-500 ml-2">Token de Autenticación (Bearer)</Label>
                        <div className="relative group">
                          <Input 
                            type="text"
                            placeholder="Ingrese el Token de integración"
                            value={payphoneConfig.token}
                            onChange={(e) => setPayphoneConfig({...payphoneConfig, token: e.target.value})}
                            className="h-14 bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 rounded-2xl font-mono text-sm px-6 pr-12 focus:border-orange-500/50"
                          />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-30 group-hover:opacity-100 transition-opacity">
                            <Key className="w-5 h-5" />
                          </div>
                        </div>
                        <p className="text-[10px] text-muted-foreground italic ml-2">
                          Token proporcionado en el panel de desarrollador de PayPhone. 
                          <span className="text-orange-500 font-bold"> Nota:</span> Por seguridad, solo verá una versión enmascarada del token guardado.
                        </p>
                      </div>

                      <div className="p-6 bg-primary/5 rounded-3xl border border-primary/10">
                        <h4 className="text-xs font-black uppercase tracking-wider text-primary mb-3 flex items-center gap-2">
                          <CheckCircle className="w-4 h-4" /> Guía de Implementación
                        </h4>
                        <ul className="space-y-2">
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-primary/20 text-primary flex items-center justify-center text-[8px] font-black shrink-0">1</div>
                            Obtén tus llaves en live.payphonetodoesposible.com
                          </li>
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-primary/20 text-primary flex items-center justify-center text-[8px] font-black shrink-0">2</div>
                            Pega el StoreID y el Token en este panel
                          </li>
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-primary/20 text-primary flex items-center justify-center text-[8px] font-black shrink-0">3</div>
                            Define un porcentaje de recargo si deseas cubrir los costos de transacción
                          </li>
                        </ul>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </TabsContent>

          {/* ── PAYPAL CONFIG TAB ── */}
          <TabsContent value="paypal" className="space-y-6 pt-6">
            <header className="flex flex-col sm:flex-row sm:items-center justify-between gap-4 mb-2">
              <div>
                <h2 className="text-3xl font-black tracking-tight text-foreground flex items-center gap-3">
                  <DollarSign className="w-8 h-8 text-[#0070ba]" /> 
                  PayPal <span className="text-[#0070ba]">Business</span>
                </h2>
                <p className="text-muted-foreground text-sm font-medium">Configura la integración con PayPal para aceptar pagos internacionales.</p>
              </div>
              <AppButton 
                onClick={handleSavePaypal} 
                loading={isSavingPaypal}
                icon={Save}
                className="bg-[#0070ba] hover:bg-[#003087] shadow-lg shadow-[#0070ba]/20 px-8 h-12 rounded-xl font-black uppercase text-xs tracking-widest"
                data-testid="save-paypal-config-btn"
              >
                Guardar Configuración
              </AppButton>
            </header>

            {/* Diagnóstico de PayPal */}
            <Card className="border-none shadow-xl bg-card overflow-hidden mb-4">
              <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                <div className="flex items-center justify-between">
                  <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                    <Activity className="w-4 h-4" /> Diagnóstico de Conexión
                  </CardTitle>
                  <AppButton
                    onClick={handleRunPaypalDiagnostics}
                    loading={isRunningPaypalDiag}
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 h-9 rounded-lg font-black uppercase text-[10px] tracking-widest"
                    data-testid="run-paypal-diagnostics-btn"
                  >
                    Ejecutar Diagnóstico
                  </AppButton>
                </div>
              </CardHeader>
              <CardContent className="pt-4">
                {!paypalDiagnostics ? (
                  <p className="text-xs text-muted-foreground italic">
                    Ejecuta el diagnóstico para verificar credenciales, autenticación y permisos de tu cuenta PayPal Business.
                  </p>
                ) : (
                  <div className="space-y-2 text-xs font-mono" data-testid="paypal-diagnostics-result">
                    <div className={`p-3 rounded-lg ${paypalDiagnostics.ok ? 'bg-emerald-50 dark:bg-emerald-950/30 text-emerald-800 dark:text-emerald-200' : 'bg-red-50 dark:bg-red-950/30 text-red-800 dark:text-red-200'}`}>
                      <p className="font-bold mb-2">
                        {paypalDiagnostics.ok ? '✅ Conexión OK' : '❌ Problema detectado'}
                      </p>
                      {paypalDiagnostics.mode && <p>Modo: <strong>{paypalDiagnostics.mode.toUpperCase()}</strong></p>}
                      {paypalDiagnostics.base_url && <p>API: {paypalDiagnostics.base_url}</p>}
                      {paypalDiagnostics.client_id_preview && <p>Client ID: {paypalDiagnostics.client_id_preview}</p>}
                      {paypalDiagnostics.auth_ok !== undefined && (
                        <p>Auth: {paypalDiagnostics.auth_ok ? '✅ OK' : '❌ Falló'}</p>
                      )}
                      {paypalDiagnostics.create_order_ok !== undefined && (
                        <p>Crear orden de prueba: {paypalDiagnostics.create_order_ok ? '✅ OK' : '❌ Falló'}</p>
                      )}
                      {paypalDiagnostics.test_order_id && <p>Test order ID: {paypalDiagnostics.test_order_id}</p>}
                      {paypalDiagnostics.error && (
                        <p className="mt-2 break-words"><strong>Error:</strong> {paypalDiagnostics.error}</p>
                      )}
                      {paypalDiagnostics.hint && (
                        <p className="mt-2 break-words p-2 bg-amber-100 dark:bg-amber-950/50 rounded text-amber-900 dark:text-amber-200">
                          💡 {paypalDiagnostics.hint}
                        </p>
                      )}
                      {paypalDiagnostics.message && (
                        <p className="mt-2 font-bold">{paypalDiagnostics.message}</p>
                      )}
                    </div>
                  </div>
                )}
              </CardContent>
            </Card>

            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Columna 1: Estado, Modo y Recargo */}
              <div className="space-y-6">
                <Card className="border-none shadow-xl bg-card overflow-hidden">
                  <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                    <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                      <Activity className="w-4 h-4" /> Estado del Servicio
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-6 space-y-6">
                    <div className="flex items-center justify-between p-4 bg-slate-50 dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                      <div className="space-y-0.5">
                        <span className="text-sm font-bold block">PayPal Checkout</span>
                        <span className="text-[10px] text-muted-foreground uppercase font-black tracking-wider">
                          {paypalConfig.activo ? 'Operativa' : 'Desactivada'}
                        </span>
                      </div>
                      <button 
                        type="button"
                        onClick={() => setPaypalConfig({...paypalConfig, activo: !paypalConfig.activo})}
                        className={`w-14 h-7 rounded-full transition-all duration-500 relative ${paypalConfig.activo ? 'bg-[#0070ba] shadow-inner' : 'bg-slate-300 dark:bg-white/10'}`}
                        data-testid="paypal-toggle-btn"
                      >
                        <div className={`absolute top-1 w-5 h-5 bg-white rounded-full shadow-lg transition-all duration-500 ${paypalConfig.activo ? 'left-8' : 'left-1'}`} />
                      </button>
                    </div>

                    {/* Modo Sandbox/Live */}
                    <div className="space-y-3 p-4 bg-[#0070ba]/5 rounded-2xl border border-[#0070ba]/10">
                      <Label className="text-[10px] font-black uppercase tracking-widest text-[#0070ba]">Modo de Operación</Label>
                      <div className="flex gap-2">
                        <button
                          onClick={() => setPaypalConfig({...paypalConfig, modo: 'sandbox'})}
                          className={`flex-1 py-3 rounded-xl font-bold uppercase text-[10px] tracking-widest transition-all ${paypalConfig.modo === 'sandbox' ? 'bg-yellow-100 dark:bg-yellow-500/20 text-yellow-700 dark:text-yellow-400 shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
                          data-testid="paypal-modo-sandbox"
                        >
                          Sandbox
                        </button>
                        <button
                          onClick={() => setPaypalConfig({...paypalConfig, modo: 'live'})}
                          className={`flex-1 py-3 rounded-xl font-bold uppercase text-[10px] tracking-widest transition-all ${paypalConfig.modo === 'live' ? 'bg-green-100 dark:bg-green-500/20 text-green-700 dark:text-green-400 shadow-sm' : 'text-muted-foreground hover:text-foreground'}`}
                          data-testid="paypal-modo-live"
                        >
                          Producción
                        </button>
                      </div>
                    </div>

                    <div className="space-y-3 p-4 bg-[#0070ba]/5 rounded-2xl border border-[#0070ba]/10">
                      <Label className="text-[10px] font-black uppercase tracking-widest text-[#0070ba]">Recargo PayPal (%)</Label>
                      <div className="flex items-center gap-4">
                        <Input 
                          type="number" 
                          step="0.01"
                          value={paypalConfig.porcentaje_adicional}
                          onChange={(e) => setPaypalConfig({...paypalConfig, porcentaje_adicional: parseFloat(e.target.value) || 0})}
                          className="h-12 text-xl font-black bg-white dark:bg-slate-900 border-[#0070ba]/20 text-center rounded-xl focus:ring-[#0070ba]"
                          data-testid="paypal-recargo-input"
                        />
                        <div className="text-[10px] text-muted-foreground font-medium uppercase leading-tight">
                          Este porcentaje se sumará al total solo en pagos con PayPal.
                        </div>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <div className="p-6 bg-slate-100 dark:bg-white/5 rounded-3xl border border-dashed border-slate-200 dark:border-white/10 flex gap-4">
                  <AlertCircle className="w-6 h-6 text-[#0070ba] shrink-0" />
                  <p className="text-[10px] text-muted-foreground font-medium leading-relaxed uppercase tracking-wider">
                    Asegúrate de que las credenciales estén correctamente configuradas. El sistema crea la orden y captura el pago directamente desde PayPal antes de confirmar los boletos.
                  </p>
                </div>
              </div>

              {/* Columna 2 y 3: Credenciales API */}
              <div className="lg:col-span-2">
                <Card className="border-none shadow-xl bg-card h-full">
                  <CardHeader className="pb-2 border-b border-slate-100 dark:border-white/5">
                    <CardTitle className="text-sm font-black uppercase tracking-widest text-muted-foreground flex items-center gap-2">
                      <ShieldCheck className="w-4 h-4" /> Credenciales PayPal
                    </CardTitle>
                  </CardHeader>
                  <CardContent className="pt-8 space-y-8">
                    <div className="grid grid-cols-1 gap-8">
                      <div className="space-y-3">
                        <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-[#0070ba] ml-2">Client ID</Label>
                        <Input 
                          placeholder="Tu Client ID de PayPal"
                          value={paypalConfig.client_id}
                          onChange={(e) => setPaypalConfig({...paypalConfig, client_id: e.target.value})}
                          className="h-14 bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 rounded-2xl font-bold text-lg px-6 focus:border-[#0070ba]/50"
                          data-testid="paypal-client-id-input"
                        />
                        <p className="text-[10px] text-muted-foreground italic ml-2">Identificador público de tu app PayPal. Se usa en frontend y backend.</p>
                      </div>

                      <div className="space-y-3">
                        <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-[#0070ba] ml-2">Client Secret</Label>
                        <div className="relative group">
                          <Input 
                            type="text"
                            placeholder="Tu Secret de PayPal"
                            value={paypalConfig.client_secret}
                            onChange={(e) => setPaypalConfig({...paypalConfig, client_secret: e.target.value})}
                            className="h-14 bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 rounded-2xl font-mono text-sm px-6 pr-12 focus:border-[#0070ba]/50"
                            data-testid="paypal-client-secret-input"
                          />
                          <div className="absolute right-4 top-1/2 -translate-y-1/2 opacity-30 group-hover:opacity-100 transition-opacity">
                            <Key className="w-5 h-5" />
                          </div>
                        </div>
                        <p className="text-[10px] text-muted-foreground italic ml-2">
                          Clave secreta de tu app PayPal. Solo se usa en backend.
                          <span className="text-[#0070ba] font-bold"> Nota:</span> Por seguridad, solo verá una versión enmascarada.
                        </p>
                      </div>

                      <div className="space-y-3">
                        <Label className="text-[10px] font-black uppercase tracking-[0.2em] text-[#0070ba] ml-2">Webhook ID (Opcional)</Label>
                        <Input 
                          placeholder="ID del Webhook para verificación"
                          value={paypalConfig.webhook_id || ''}
                          onChange={(e) => setPaypalConfig({...paypalConfig, webhook_id: e.target.value})}
                          className="h-14 bg-slate-50 dark:bg-white/5 border-slate-100 dark:border-white/10 rounded-2xl font-mono text-sm px-6 focus:border-[#0070ba]/50"
                          data-testid="paypal-webhook-id-input"
                        />
                        <p className="text-[10px] text-muted-foreground italic ml-2">Para verificar firmas de webhooks PayPal (opcional pero recomendado).</p>
                      </div>

                      <div className="p-6 bg-[#0070ba]/5 rounded-3xl border border-[#0070ba]/10">
                        <h4 className="text-xs font-black uppercase tracking-wider text-[#0070ba] mb-3 flex items-center gap-2">
                          <CheckCircle className="w-4 h-4" /> Guía de Configuración
                        </h4>
                        <ul className="space-y-2">
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-[#0070ba]/20 text-[#0070ba] flex items-center justify-center text-[8px] font-black shrink-0">1</div>
                            Ve a developer.paypal.com y crea una App
                          </li>
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-[#0070ba]/20 text-[#0070ba] flex items-center justify-center text-[8px] font-black shrink-0">2</div>
                            Copia el Client ID y Secret en este panel
                          </li>
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-[#0070ba]/20 text-[#0070ba] flex items-center justify-center text-[8px] font-black shrink-0">3</div>
                            Selecciona Sandbox para pruebas o Producción para cobros reales
                          </li>
                          <li className="flex items-start gap-3 text-[10px] font-medium text-slate-600 dark:text-white/60 uppercase tracking-wide">
                            <div className="w-4 h-4 rounded-full bg-[#0070ba]/20 text-[#0070ba] flex items-center justify-center text-[8px] font-black shrink-0">4</div>
                            Configura el Webhook URL: tu-dominio.com/api/paypal/webhook
                          </li>
                        </ul>
                      </div>
                    </div>
                  </CardContent>
                </Card>
              </div>
            </div>
          </TabsContent>

          <TabsContent value="configuracion" className="space-y-6 pt-6">
            <header className="mb-6">
              <h2 className="text-3xl font-black tracking-tight text-foreground flex items-center gap-3">
                <Settings className="w-8 h-8 text-orange-500" /> 
                Mi <span className="text-orange-500">Perfil</span>
              </h2>
              <p className="text-muted-foreground text-sm font-medium">Gestiona tu información personal y credenciales de acceso.</p>
            </header>
            
            <Card className="border-none shadow-xl bg-card overflow-hidden">
               <CardContent className="p-8">
                  <div className="flex flex-col md:flex-row gap-10 items-start">
                    <div className="w-full md:w-1/3 flex flex-col items-center gap-6 p-8 bg-slate-50 dark:bg-white/5 rounded-[2.5rem] border border-slate-100 dark:border-white/5">
                        <div className="w-32 h-32 rounded-full bg-orange-500 p-1 shadow-2xl shadow-orange-500/20">
                          <div className="w-full h-full rounded-full bg-white dark:bg-slate-900 flex items-center justify-center overflow-hidden">
                             <User className="w-16 h-16 text-orange-500" />
                          </div>
                        </div>
                        <div className="text-center space-y-1">
                          <h3 className="text-xl font-black">{user?.name}</h3>
                          <Badge className="bg-orange-500/10 text-orange-500 uppercase font-black text-[10px] border-none shadow-none">
                            ADMINISTRADOR MASTER
                          </Badge>
                        </div>
                        <AppButton 
                          variant="danger" 
                          icon={LogOut} 
                          onClick={handleLogout}
                          className="w-full h-12 rounded-2xl font-black uppercase text-xs tracking-widest"
                        >
                          Cerrar Sesión
                        </AppButton>
                    </div>

                    <div className="flex-1 w-full space-y-8">
                      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                        <div className="space-y-2">
                          <Label className="text-[10px] font-black uppercase tracking-widest text-muted-foreground ml-1">Email Registrado</Label>
                          <div className="h-12 flex items-center px-4 bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 rounded-xl font-bold text-slate-500">
                             {user?.email}
                          </div>
                        </div>
                        <div className="space-y-2">
                          <Label className="text-[10px] font-black uppercase tracking-widest text-muted-foreground ml-1">Rol de Acceso</Label>
                          <div className="h-12 flex items-center px-4 bg-slate-50 dark:bg-white/5 border border-slate-100 dark:border-white/5 rounded-xl font-bold text-slate-500 uppercase tracking-tighter">
                             {user?.role}
                          </div>
                        </div>
                      </div>

                      <div className="pt-6 border-t border-slate-100 dark:border-white/5">
                        <h4 className="text-lg font-black mb-4">Seguridad de la Cuenta</h4>
                        <AppButton 
                          variant="secondary" 
                          icon={Key}
                          onClick={() => setShowChangePassword(true)}
                          className="h-14 px-8 rounded-2xl font-black uppercase text-xs tracking-widest"
                        >
                          Cambiar Contraseña de Acceso
                        </AppButton>
                      </div>
                    </div>
                  </div>
               </CardContent>
            </Card>
          </TabsContent>

          <TabsContent value="campanas" className="pt-6">
            <CampañasManager />
          </TabsContent>

          <TabsContent value="respaldos" className="space-y-6 pt-6">
             <BackupManager />
          </TabsContent>

          <TabsContent value="marketing" className="space-y-6 pt-6">
             <MarketingManager />
          </TabsContent>
          {/* Tab de Branding / Identidad Visual */}
          <TabsContent value="branding" className="space-y-6 pt-6 animate-in fade-in slide-in-from-bottom-4 duration-500">
            <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
              {/* Bloque de Gestión de Logo */}
              <div className="lg:col-span-2 space-y-6">
                <Card className="border-none shadow-xl bg-white/80 dark:bg-slate-900/80 backdrop-blur-xl overflow-hidden">
                  <div className="bg-gradient-to-r from-purple-500 to-indigo-600 h-2 w-full" />
                  <CardHeader className="pb-2">
                    <div className="flex items-center gap-3">
                      <div className="p-2 bg-purple-100 dark:bg-purple-900/30 rounded-xl">
                        <Image className="w-6 h-6 text-purple-600 dark:text-purple-400" />
                      </div>
                      <div>
                        <CardTitle className="text-xl font-bold">Identidad Visual</CardTitle>
                        <CardDescription>Gestiona el logo principal de la plataforma</CardDescription>
                      </div>
                    </div>
                  </CardHeader>
                  <CardContent className="space-y-8 p-8">
                    {/* Preview Section */}
                    <div className="space-y-4">
                      <Label className="text-sm font-black uppercase tracking-widest text-slate-500 ml-1">Vista Previa Actual</Label>
                      <div className="relative group">
                        <div className="h-64 w-full rounded-2xl border-2 border-dashed border-slate-200 dark:border-white/10 flex items-center justify-center p-8 bg-slate-50/50 dark:bg-slate-950/20 overflow-hidden transition-all group-hover:bg-slate-50 dark:group-hover:bg-slate-950/40">
                          {logoPreview ? (
                            <img 
                              src={logoPreview} 
                              alt="Logo preview" 
                              className="max-h-full max-w-full object-contain drop-shadow-2xl transition-transform duration-500 group-hover:scale-105" 
                            />
                          ) : (
                            <div className="text-center space-y-3">
                              <Image className="w-16 h-16 text-slate-300 dark:text-slate-700 mx-auto" />
                              <p className="text-sm text-slate-400">No hay un logo configurado</p>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Controls */}
                    <div className="space-y-4 pt-4 border-t border-slate-100 dark:border-white/5">
                      <div className="flex flex-col md:flex-row gap-4">
                        <div className="flex-1">
                          <input 
                            type="file" 
                            id="logo-upload-input" 
                            className="hidden" 
                            accept="image/*"
                            onChange={handleLogoFileChange}
                          />
                          <Label 
                            htmlFor="logo-upload-input"
                            className="flex items-center justify-center gap-3 h-14 w-full rounded-xl border-2 border-slate-200 dark:border-white/10 bg-white dark:bg-slate-900 hover:border-purple-500 dark:hover:border-purple-400 cursor-pointer transition-all hover:bg-purple-50/50 dark:hover:bg-purple-950/10 active:scale-[0.98]"
                          >
                            <Camera className="w-5 h-5 text-purple-500" />
                            <span className="font-bold text-slate-700 dark:text-slate-200">
                              {selectedLogoFile ? 'Elegir otro archivo' : 'Seleccionar nuevo logo'}
                            </span>
                          </Label>
                        </div>
                        
                        <AppButton 
                          onClick={handleUpdateLogo}
                          disabled={!selectedLogoFile || uploadingLogo}
                          className="md:w-48 h-14 rounded-xl bg-purple-600 hover:bg-purple-700 text-white font-black uppercase tracking-widest text-[10px] shadow-lg shadow-purple-500/20 active:scale-95 disabled:opacity-50"
                        >
                          {uploadingLogo ? (
                            <Loader2 className="w-5 h-5 animate-spin mx-auto" />
                          ) : (
                            <div className="flex items-center gap-2 mx-auto">
                              <Save className="w-4 h-4" />
                              Guardar Cambios
                            </div>
                          )}
                        </AppButton>
                      </div>

                      {selectedLogoFile && (
                        <div className="flex items-center gap-3 p-4 bg-purple-50 dark:bg-purple-900/20 rounded-xl border border-purple-100 dark:border-purple-900/30 animate-in fade-in slide-in-from-left-2">
                          <div className="p-2 bg-purple-200 dark:bg-purple-800 rounded-lg">
                            <Image className="w-4 h-4 text-purple-700 dark:text-purple-300" />
                          </div>
                          <div className="flex-1 overflow-hidden">
                            <p className="text-sm font-bold text-purple-900 dark:text-purple-300 truncate">{selectedLogoFile.name}</p>
                            <p className="text-[10px] text-purple-600 dark:text-purple-400 uppercase tracking-widest">Listo para subir</p>
                          </div>
                          <button 
                            onClick={() => {
                              setSelectedLogoFile(null);
                              setLogoPreview(getMediaUrl(branding.logo_url));
                            }}
                            className="p-2 hover:bg-purple-200 dark:hover:bg-purple-800 rounded-full transition-colors"
                          >
                            <X className="w-4 h-4 text-purple-700 dark:text-purple-300" />
                          </button>
                        </div>
                      )}
                    </div>
                  </CardContent>
                </Card>

                {/* Info Box */}
                <div className="p-6 bg-slate-900 text-white rounded-2xl shadow-xl flex gap-5 items-start">
                  <div className="p-3 bg-white/10 rounded-xl">
                    <Zap className="w-6 h-6 text-yellow-400" />
                  </div>
                  <div className="space-y-2">
                    <h5 className="font-bold text-white">Impacto del Cambio</h5>
                    <p className="text-sm text-slate-400 leading-relaxed">
                      El logo que subas aquí se reflejará automáticamente en la <span className="text-white font-bold">Página de Inicio</span>, el <span className="text-white font-bold">Centro de Registro</span> y la <span className="text-white font-bold">Pantalla de Login</span>.
                    </p>
                    <div className="flex gap-2 pt-2">
                      <span className="px-2 py-1 bg-white/5 rounded text-[10px] font-black uppercase tracking-widest text-slate-400">Sin basura en servidor</span>
                      <span className="px-2 py-1 bg-white/5 rounded text-[10px] font-black uppercase tracking-widest text-slate-400">Limpieza automática</span>
                    </div>
                  </div>
                </div>
              </div>

              {/* Sidebar / Tips */}
              <div className="space-y-6">
                <Card className="border-none shadow-xl bg-white dark:bg-slate-900">
                  <CardHeader>
                    <CardTitle className="text-lg font-bold">Recomendaciones</CardTitle>
                  </CardHeader>
                  <CardContent className="space-y-5">
                    <div className="flex gap-4 items-start">
                      <div className="mt-1 w-2 h-2 rounded-full bg-purple-500 shrink-0" />
                      <div className="space-y-1">
                        <p className="text-sm font-bold">Formato sugerido</p>
                        <p className="text-xs text-slate-500">Usa archivos PNG con fondo transparente o SVG para mejor calidad.</p>
                      </div>
                    </div>
                    <div className="flex gap-4 items-start">
                      <div className="mt-1 w-2 h-2 rounded-full bg-purple-500 shrink-0" />
                      <div className="space-y-1">
                        <p className="text-sm font-bold">Proporciones</p>
                        <p className="text-xs text-slate-500">Un logo horizontal funciona mejor para el header del Home.</p>
                      </div>
                    </div>
                    <div className="flex gap-4 items-start">
                      <div className="mt-1 w-2 h-2 rounded-full bg-purple-500 shrink-0" />
                      <div className="space-y-1">
                        <p className="text-sm font-bold">Contraste</p>
                        <p className="text-xs text-slate-500">Asegúrate de que tu logo sea visible tanto en modo claro como oscuro.</p>
                      </div>
                    </div>
                  </CardContent>
                </Card>

                <div className="p-8 border-2 border-dashed border-slate-200 dark:border-white/10 rounded-3xl flex flex-col items-center text-center space-y-4">
                  <div className="w-16 h-16 bg-slate-50 dark:bg-white/5 rounded-full flex items-center justify-center">
                    <LogOut className="w-8 h-8 text-slate-400" />
                  </div>
                  <div className="space-y-1">
                    <p className="text-sm font-bold text-slate-700 dark:text-slate-200">Seguridad</p>
                    <p className="text-xs text-slate-500">Al subir un nuevo logo, el archivo anterior es eliminado físicamente del servidor para ahorrar espacio.</p>
                  </div>
                </div>
              </div>
            </div>
          </TabsContent>
        </Tabs>
      </div>
      
      {/* Modal para aprobar retiro */}
      <Dialog open={showAprobarRetiro} onOpenChange={setShowAprobarRetiro}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>Aprobar Retiro</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p>Monto a aprobar: <strong>{retiroSeleccionado && formatCurrency(retiroSeleccionado.monto)}</strong></p>
            <p>Vendedor: <strong>{retiroSeleccionado?.vendedor?.name}</strong></p>
            
            <div>
              <Label>URL del Comprobante de Transferencia</Label>
              <Input
                type="url"
                value={comprobanteUrl}
                onChange={(e) => setComprobanteUrl(e.target.value)}
                placeholder="https://..."
                required
              />
              <p className="text-xs text-gray-500 mt-1">
                Sube el comprobante a un servicio como Imgur o Google Drive y pega la URL aquí
              </p>
            </div>
            
            <div className="flex gap-2">
              <AppButton variant="success" onClick={handleAprobarRetiro} className="flex-1">
                Aprobar y Enviar
              </AppButton>
              <AppButton onClick={() => setShowAprobarRetiro(false)} variant="ghost" className="flex-1">
                Cancelar
              </AppButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>

      {/* Modal de Configuración Operativa (del botón Min/Config) */}
      <Dialog open={!!configOperativa} onOpenChange={cerrarConfigOperativa}>
        <DialogContent className="max-w-md bg-card border-none shadow-2xl">
          <DialogHeader>
            <DialogTitle className="flex items-center gap-2 text-xl font-bold">
              <Settings className="w-5 h-5 text-orange-500" />
              Configuración Operativa
            </DialogTitle>
            <DialogDescription>
              Ajusta los parámetros críticos del sorteo en tiempo real.
            </DialogDescription>
          </DialogHeader>

          {configOperativa && (
            <div className="space-y-6 py-4">
              {/* Sección 1: Boletos */}
              <div className="space-y-3 p-4 bg-slate-50 dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                <h4 className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Boletos</h4>
                <div className="flex justify-between items-end gap-4">
                  <div className="space-y-1 flex-1">
                    <Label className="text-sm font-medium">Total de Boletos</Label>
                    <Input
                      type="number"
                      value={nuevoTotalBoletos}
                      onChange={(e) => setNuevoTotalBoletos(parseInt(e.target.value) || 0)}
                      disabled={loadingConfig}
                      className="h-11 border-slate-200 focus:ring-orange-500"
                    />
                  </div>
                  <div className="space-y-1 w-24">
                    <Label className="text-sm font-medium">Mínimo</Label>
                    <Input
                      type="number"
                      min="1"
                      value={nuevoMinimoBoletos}
                      onChange={(e) => setNuevoMinimoBoletos(parseInt(e.target.value) || 1)}
                      disabled={loadingConfig}
                      className="h-11 border-slate-200 focus:ring-orange-500"
                    />
                  </div>
                  <div className="text-right pb-1">
                    <span className="block text-[10px] uppercase text-muted-foreground font-bold">Vendidos</span>
                    <span className="text-lg font-black">{configOperativa.cantidad_vendida}</span>
                  </div>
                </div>
                {nuevoTotalBoletos < configOperativa.cantidad_vendida && (
                  <p className="text-[10px] text-red-500 font-bold animate-pulse">
                    ⚠️ El total no puede ser menor a los vendidos
                  </p>
                )}
              </div>

              {/* Sección 2: Cierre Manual */}
              <div className="space-y-3 p-4 bg-slate-50 dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                <h4 className="text-xs font-bold uppercase tracking-wider text-muted-foreground">Cierre Estratégico</h4>
                <div className="space-y-1">
                  <Label className="text-sm font-medium">Habilitar Cierre Manual al (%)</Label>
                  <div className="flex items-center gap-4">
                    <Input
                      type="number"
                      min="1"
                      max="99"
                      value={nuevoPorcentajeManual}
                      onChange={(e) => setNuevoPorcentajeManual(parseInt(e.target.value) || 0)}
                      disabled={loadingConfig}
                      className="h-11 w-24 border-slate-200 focus:ring-orange-500"
                    />
                    <div className="flex-1 text-xs text-muted-foreground leading-tight">
                      El botón "Cerrar Sorteo" se activará cuando el progreso llegue a este valor.
                    </div>
                  </div>
                </div>
              </div>

              {/* Sección 3: Métricas */}
              <div className="grid grid-cols-1 gap-3">
                <div className="p-3 bg-slate-50 dark:bg-white/5 rounded-xl border border-slate-100 dark:border-white/5">
                  <span className="block text-[10px] uppercase text-muted-foreground font-bold mb-1">Progreso Actual</span>
                  <div className="flex items-end gap-1">
                    <span className="text-xl font-black">{configOperativa.progreso_porcentaje?.toFixed(1)}%</span>
                  </div>
                </div>
              </div>

              {/* Botón de Cierre Manual (solo si aplica) */}
              {configOperativa.progreso_porcentaje >= (configOperativa.porcentaje_cierre_manual || 100) && (
                <AppButton 
                  variant="danger" 
                  className="w-full h-12 shadow-lg shadow-red-500/20"
                  onClick={() => ejecutarCierreManual(configOperativa.id)}
                  disabled={loadingConfig}
                  icon={ShieldOff}
                >
                  Cerrar Sorteo Manualmente
                </AppButton>
              )}

              {/* Acciones del Modal */}
              <div className="flex gap-3 pt-2">
                <AppButton 
                  variant="primary" 
                  className="flex-1 h-12 font-bold"
                  onClick={guardarConfigOperativa}
                  loading={loadingConfig}
                  disabled={nuevoTotalBoletos < configOperativa.cantidad_vendida || loadingConfig}
                  icon={Save}
                >
                  Guardar Cambios
                </AppButton>
                <Button 
                  variant="ghost" 
                  type="button"
                  className="h-12 px-6 rounded-xl"
                  onClick={cerrarConfigOperativa}
                  disabled={loadingConfig}
                >
                  Cancelar
                </Button>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* Dialog de Confirmación Genérico (reemplaza window.confirm) */}
      <Dialog open={confirmDialog.open} onOpenChange={(open) => setConfirmDialog({ ...confirmDialog, open })}>
        <DialogContent>
          <DialogHeader>
            <DialogTitle>{confirmDialog.title}</DialogTitle>
          </DialogHeader>
          <div className="space-y-4">
            <p className="text-sm text-gray-600 whitespace-pre-line">{confirmDialog.message}</p>
            <div className="flex gap-2 justify-end">
              <AppButton variant="ghost" onClick={() => setConfirmDialog({ ...confirmDialog, open: false })}>
                Cancelar
              </AppButton>
              <AppButton 
                variant="primary"
                onClick={async () => {
                  setConfirmDialog({ ...confirmDialog, open: false });
                  if (confirmDialog.onConfirm) {
                    await confirmDialog.onConfirm();
                  }
                }}
              >
                Confirmar
              </AppButton>
            </div>
          </div>
        </DialogContent>
      </Dialog>

    {/* =====  BANNER POST-APROBACIÓN WHATSAPP ===== */}
    {waPostApproval && (
      <div className="fixed bottom-6 right-6 z-50 w-80 bg-green-900 border border-green-500/30 rounded-3xl shadow-2xl shadow-green-900/50 p-5 space-y-4 animate-in slide-in-from-bottom-6 duration-500">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-green-400 shrink-0" />
            <p className="text-sm font-black text-white">¡Aprobación exitosa!</p>
          </div>
          <button onClick={() => setWaPostApproval(null)} className="text-white/50 hover:text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-xs text-green-200 font-medium">
          Notifica al cliente <strong>{waPostApproval.cliente?.nombre || 'cliente'}</strong> que sus boletos fueron aprobados.
        </p>
        <a
          href={buildWAUrl(waPostApproval.cliente?.celular, waConfirmacionAprobacion(waPostApproval))}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setWaPostApproval(null)}
        >
          <AppButton
            variant="success"
            className="w-full h-11 rounded-2xl font-black bg-green-500 hover:bg-green-400 border-none text-white"
            icon={MessageSquare}
          >
            Enviar Confirmación por WA
          </AppButton>
        </a>
        <button onClick={() => setWaPostApproval(null)} className="w-full text-xs text-green-400/70 hover:text-green-300 text-center transition-colors">
          Omitir ›
        </button>
      </div>
    )}

    {/* ===== BANNER POST-RECHAZO WHATSAPP ===== */}
    {waPostRejection && (
      <div className="fixed bottom-6 right-6 z-50 w-80 bg-red-900 border border-red-500/30 rounded-3xl shadow-2xl shadow-red-900/50 p-5 space-y-4 animate-in slide-in-from-bottom-6 duration-500">
        <div className="flex items-start justify-between gap-3">
          <div className="flex items-center gap-2">
            <MessageSquare className="w-5 h-5 text-red-400 shrink-0" />
            <p className="text-sm font-black text-white">Boleto Rechazado</p>
          </div>
          <button onClick={() => setWaPostRejection(null)} className="text-white/50 hover:text-white transition-colors">
            <X className="w-4 h-4" />
          </button>
        </div>
        <p className="text-xs text-red-200 font-medium">
          ¿Deseas notificar al cliente <strong>{waPostRejection.cliente?.nombre || 'cliente'}</strong> sobre el rechazo?
        </p>
        <a
          href={buildWAUrl(waPostRejection.cliente?.celular, waNotificacionRechazo(waPostRejection))}
          target="_blank"
          rel="noopener noreferrer"
          onClick={() => setWaPostRejection(null)}
        >
          <AppButton
            variant="danger"
            className="w-full h-11 rounded-2xl font-black bg-red-500 hover:bg-red-400 border-none text-white"
            icon={MessageSquare}
          >
            Notificar Rechazo por WA
          </AppButton>
        </a>
        <button onClick={() => setWaPostRejection(null)} className="w-full text-xs text-red-400/70 hover:text-red-300 text-center transition-colors">
          Omitir ›
        </button>
      </div>
    )}

    {/* Modal para aprobar boleto/compra */}
    <Dialog open={dialogAprobarOpen} onOpenChange={setDialogAprobarOpen}>
      <DialogContent className="max-w-md bg-card border-none shadow-2xl">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2 text-xl font-bold">
            <CheckCircle className="w-5 h-5 text-green-500" />
            Aprobar Compra
          </DialogTitle>
          <DialogDescription>
            Ingresa el número de comprobante para validar esta transacción.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="space-y-2">
            <Label htmlFor="num-comprobante" className="text-sm font-bold uppercase tracking-wider text-muted-foreground">
              Número de Comprobante / Referencia
            </Label>
            <Input
              id="num-comprobante"
              placeholder="---"
              value={numeroComprobante}
              onChange={(e) => setNumeroComprobante(e.target.value)}
              className="h-12 text-lg font-bold border-slate-200 focus:ring-green-500"
              autoFocus
              onKeyDown={(e) => {
                if (e.key === 'Enter') handleAprobarBoleto();
              }}
            />
          </div>

          <div className="flex gap-3 pt-2">
            <AppButton
              variant="success"
              className="flex-1 h-12 font-black"
              onClick={handleAprobarBoleto}
              loading={isApproving}
              icon={CheckCircle}
            >
              Confirmar Aprobación
            </AppButton>
            <Button
              variant="ghost" 
              type="button"
              className="h-12 px-6 rounded-xl font-bold"
              onClick={() => {
                setDialogAprobarOpen(false);
                setNumeroComprobante('');
              }}
              disabled={isApproving}
            >
              Cancelar
            </Button>
          </div>
        </div>
      </DialogContent>
    </Dialog>

    {/* Modal para Reset Password */}
    <Dialog open={showResetPasswordModal} onOpenChange={setShowResetPasswordModal}>
      <DialogContent className="max-w-md bg-card border-none shadow-2xl rounded-[2rem]">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-3 text-2xl font-black">
            <div className="h-10 w-10 rounded-xl bg-orange-500/10 flex items-center justify-center">
              <Key className="w-6 h-6 text-orange-500" />
            </div>
            Resetear Contraseña
          </DialogTitle>
          <DialogDescription className="font-medium">
            Estás gestionando el acceso para <span className="text-foreground font-bold">{selectedUserReset?.name}</span>
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-6 py-4">
          {!passwordReseteada ? (
            <div className="space-y-4">
              <div className="space-y-2">
                <Label className="text-xs font-black uppercase text-muted-foreground tracking-widest">Nueva Contraseña</Label>
                <div className="flex gap-2">
                  <Input
                    placeholder="---"
                    value={newPasswordReset}
                    onChange={(e) => setNewPasswordReset(e.target.value)}
                    className="h-12 font-bold border-slate-200 focus:ring-orange-500 text-center text-lg"
                  />
                  <AppButton
                    variant="outline"
                    className="h-12 w-12 border-slate-200 rounded-xl"
                    onClick={generarPasswordAutomatico}
                    icon={Sparkles}
                    title="Generar contraseña segura"
                  />
                </div>
              </div>

              <AppButton
                variant="primary"
                className="w-full h-14 text-lg font-black shadow-lg shadow-orange-500/20"
                onClick={handleResetPassword}
                loading={isResetting}
                icon={Save}
              >
                Actualizar Contraseña
              </AppButton>
            </div>
          ) : (
            <div className="animate-in zoom-in duration-300 space-y-6">
              <div className="p-6 bg-green-500/10 border border-green-500/20 rounded-3xl text-center">
                <div className="h-16 w-16 bg-green-500 rounded-full mx-auto flex items-center justify-center mb-4 shadow-lg shadow-green-500/20">
                  <CheckCircle className="w-10 h-10 text-white" />
                </div>
                <h4 className="text-xl font-black text-green-600 mb-1">¡Éxito!</h4>
                <p className="text-sm font-medium text-green-700">La nueva contraseña se ha guardado correctamente.</p>
              </div>

              <div className="space-y-3">
                <p className="text-center text-xs font-black uppercase text-muted-foreground tracking-widest">Envía las credenciales al usuario</p>
                
                <div className="grid grid-cols-1 gap-3">
                  <AppButton
                    variant="success"
                    className="h-14 font-black text-lg bg-[#25D366] hover:bg-[#128C7E] border-none shadow-xl shadow-green-500/10"
                    onClick={enviarWhatsAppPassword}
                    icon={MessageCircle}
                  >
                    Enviar por WhatsApp
                  </AppButton>
                  
                  <div className="flex gap-2">
                    <div className="flex-1 overflow-hidden h-12 bg-slate-100 dark:bg-white/5 border border-slate-200 dark:border-white/10 rounded-xl flex items-center px-4 font-mono text-sm">
                      {newPasswordReset}
                    </div>
                    <AppButton
                      variant="outline"
                      className="h-12 px-6 rounded-xl font-bold border-slate-200"
                      onClick={() => {
                        navigator.clipboard.writeText(newPasswordReset);
                        toast.success('Copiado al portapapeles');
                      }}
                      icon={Copy}
                    >
                      Copiar
                    </AppButton>
                  </div>
                </div>
              </div>

              <AppButton
                variant="outline"
                className="w-full h-12 font-bold"
                onClick={() => setShowResetPasswordModal(false)}
              >
                Cerrar Panel
              </AppButton>
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>

    <Dialog open={boletosUsuarioModalOpen} onOpenChange={setBoletosUsuarioModalOpen}>
      <DialogContent className="sm:max-w-4xl max-h-[90vh] overflow-y-auto rounded-3xl border-0 bg-slate-50 dark:bg-slate-900 p-0 shadow-2xl overflow-hidden flex flex-col">
        <div className="bg-gradient-to-br from-orange-400 to-orange-600 p-6 flex-shrink-0 relative overflow-hidden">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/10 rounded-full blur-3xl -translate-y-1/2 translate-x-1/3"></div>
          <DialogHeader>
            <DialogTitle className="text-2xl font-black text-white flex items-center gap-3 relative z-10">
              <div className="h-10 w-10 rounded-xl bg-white/20 backdrop-blur-sm flex items-center justify-center shadow-inner">
                <Ticket className="w-5 h-5 text-white" />
              </div>
              Boletos de {usuarioSeleccionadoBoletos?.name || 'Usuario'}
            </DialogTitle>
            <DialogDescription className="text-orange-100 font-medium relative z-10">
              Visualiza, aprueba y rechaza los boletos de este usuario
            </DialogDescription>
          </DialogHeader>
        </div>

        <div className="p-6 flex-1 overflow-y-auto">
          {loadingBoletosUsuario ? (
            <div className="flex flex-col items-center justify-center py-12 gap-4">
              <div className="h-10 w-10 rounded-full border-4 border-orange-500/20 border-t-orange-500 animate-spin"></div>
              <span className="font-bold text-muted-foreground animate-pulse">Cargando boletos...</span>
            </div>
          ) : (
            <Tabs defaultValue="pendientes" className="w-full">
              <TabsList className="w-full h-14 bg-slate-200/50 dark:bg-white/5 p-1 rounded-2xl mb-6">
                <TabsTrigger value="pendientes" className="flex-1 h-full rounded-xl data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:shadow-md transition-all font-bold text-sm gap-2">
                  <div className="w-6 h-6 rounded-lg bg-orange-100 dark:bg-orange-500/20 text-orange-600 flex items-center justify-center text-xs font-black">
                    {boletosUsuarioSeleccionado.pendientes?.length || 0}
                  </div>
                  Pendientes
                </TabsTrigger>
                <TabsTrigger value="aprobados" className="flex-1 h-full rounded-xl data-[state=active]:bg-white dark:data-[state=active]:bg-slate-800 data-[state=active]:shadow-md transition-all font-bold text-sm gap-2">
                  <div className="w-6 h-6 rounded-lg bg-emerald-100 dark:bg-emerald-500/20 text-emerald-600 flex items-center justify-center text-xs font-black">
                    {boletosUsuarioSeleccionado.aprobados?.length || 0}
                  </div>
                  Aprobados
                </TabsTrigger>
              </TabsList>

              <TabsContent value="pendientes" className="space-y-4">
                {(() => {
                  if (!boletosUsuarioSeleccionado.pendientes || boletosUsuarioSeleccionado.pendientes.length === 0) {
                    return (
                      <div className="text-center py-12 bg-white dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                        <CheckCircle className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto mb-3" />
                        <h3 className="text-lg font-bold text-slate-700 dark:text-slate-300">Sin boletos pendientes</h3>
                        <p className="text-slate-500 text-sm mt-1">Este usuario no tiene compras por aprobar.</p>
                      </div>
                    );
                  }

                  const solicitudesMap = new Map();
                  boletosUsuarioSeleccionado.pendientes.forEach(b => {
                    const pid = b.purchase_id || `ind_${b.id}`;
                    if (!solicitudesMap.has(pid)) solicitudesMap.set(pid, []);
                    solicitudesMap.get(pid).push(b);
                  });
                  const solicitudesUsuario = Array.from(solicitudesMap.values());

                  return (
                    <div className="grid gap-6">
                      {solicitudesUsuario.map(group => {
                        const sample = group[0];
                        const totalMonto = group.reduce((acc, b) => acc + (b.precio_pagado || 0), 0);
                        const displayTitle = group.length > 1 ? `Compra de ${group.length} boletos` : `Compra de 1 boleto`;

                        return (
                          <Card key={sample.purchase_id || sample.id} className="group border-none shadow-xl bg-card overflow-hidden transition-all duration-300 hover:shadow-2xl">
                            <div className="p-6 flex flex-col lg:flex-row gap-6">
                              <div className="flex-1 space-y-4">
                                <div className="flex items-center justify-between">
                                  <div>
                                    <h4 className="text-lg font-black tracking-tight">{displayTitle}</h4>
                                    <span className="text-xs font-bold text-muted-foreground uppercase">
                                      {formatDateTime(sample.fecha_compra)} • {sample.sorteo?.titulo || 'Sorteo Desconocido'}
                                    </span>
                                  </div>
                                  <Badge className="bg-yellow-500/10 text-yellow-600 dark:text-yellow-400 border border-yellow-500/20 uppercase font-black text-[10px] h-6 px-2 shadow-none">
                                    Pendiente
                                  </Badge>
                                </div>

                                <div className="space-y-2">
                                  <Label className="text-xs font-black uppercase text-muted-foreground tracking-widest">Boletos Reservados</Label>
                                  <div className="flex flex-wrap gap-2">
                                    {group.map(b => (
                                      <span key={b.id} className="h-8 px-3 rounded-xl bg-slate-100 dark:bg-white/10 text-foreground font-black text-xs flex items-center justify-center border border-slate-200 dark:border-white/10">
                                        #{b.numero_boleto.toString().padStart(4, '0')}
                                      </span>
                                    ))}
                                  </div>
                                </div>

                                {sample.comprobante_url && (
                                  <div className="mt-3 rounded-xl overflow-hidden border border-slate-100 dark:border-white/5 w-48 h-32">
                                    <img src={getMediaUrl(sample.comprobante_url)} alt="Comprobante" className="w-full h-full object-cover cursor-pointer hover:opacity-90 transition-opacity" onClick={() => window.open(getMediaUrl(sample.comprobante_url), '_blank')} />
                                  </div>
                                )}
                              </div>

                              <div className="lg:w-64 flex flex-col justify-between border-t lg:border-t-0 lg:border-l border-slate-100 dark:border-white/5 lg:pl-6 pt-4 lg:pt-0">
                                <div className="space-y-2 mb-6">
                                  <div className="flex flex-col items-start lg:items-end">
                                    <span className="text-[10px] font-black uppercase text-muted-foreground tracking-widest mb-1">Monto a Cobrar</span>
                                    <span className="text-3xl font-black text-primary drop-shadow-sm">
                                      {formatCurrency(totalMonto)}
                                    </span>
                                    <span className="text-[10px] font-bold text-muted-foreground mt-1 bg-slate-100 dark:bg-white/10 px-2 py-0.5 rounded-full">
                                      ({formatCurrency(sample.precio_pagado)} × {group.length})
                                    </span>
                                  </div>
                                </div>

                                <div className="space-y-2">
                                  <a
                                    href={buildWAUrl(
                                      sample.usuario?.celular,
                                      waAvisoRevision({
                                        nombresorteo: sample.sorteo?.titulo || 'Sorteo',
                                        cliente: sample.usuario,
                                        numeros_boletos: group.map(b => b.numero_boleto),
                                        totalMonto,
                                      })
                                    )}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                  >
                                    <AppButton
                                      variant="secondary"
                                      className="w-full h-9 rounded-xl font-black text-[10px] border-green-500/30 text-green-600 dark:text-green-400 bg-green-500/5 hover:bg-green-500 hover:text-white mb-2"
                                      icon={MessageSquare}
                                    >
                                      WhatsApp: Avisar
                                    </AppButton>
                                  </a>
                                  <div className="flex gap-2">
                                    <AppButton 
                                      variant="success" 
                                      className="flex-1 h-10 rounded-xl font-black text-xs shadow-lg shadow-green-500/20"
                                      onClick={() => {
                                        setBoletoAprobar(sample.id);
                                        setDialogAprobarOpen(true);
                                      }}
                                    >
                                      Aprobar
                                    </AppButton>
                                    <AppButton 
                                      variant="danger" 
                                      className="flex-1 h-10 rounded-xl font-black text-xs shadow-lg shadow-red-500/20"
                                      onClick={() => handleRechazarBoleto(sample.id, { usuario: sample.usuario, group })}
                                    >
                                      Rechazar
                                    </AppButton>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </Card>
                        );
                      })}
                    </div>
                  );
                })()}
              </TabsContent>

              <TabsContent value="aprobados" className="space-y-4">
                {boletosUsuarioSeleccionado.aprobados?.length === 0 ? (
                  <div className="text-center py-12 bg-white dark:bg-white/5 rounded-2xl border border-slate-100 dark:border-white/5">
                    <Ticket className="w-12 h-12 text-slate-300 dark:text-slate-600 mx-auto mb-3" />
                    <h3 className="text-lg font-bold text-slate-700 dark:text-slate-300">Sin boletos aprobados</h3>
                    <p className="text-slate-500 text-sm mt-1">Este usuario aún no tiene boletos confirmados.</p>
                  </div>
                ) : (
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    {boletosUsuarioSeleccionado.aprobados?.map(boleto => (
                      <Card key={boleto.id} className="overflow-hidden border-emerald-100 dark:border-emerald-500/20 bg-emerald-50/30 dark:bg-emerald-900/10 rounded-2xl shadow-sm">
                        <CardContent className="p-4">
                          <div className="flex justify-between items-start">
                            <div>
                              <Badge variant="success" className="mb-2 border-emerald-200 text-emerald-600 bg-emerald-50 dark:bg-emerald-500/10">Boleto #{boleto.numero_boleto}</Badge>
                              <h4 className="font-bold text-sm line-clamp-1">{boleto.sorteo?.titulo || 'Sorteo Desconocido'}</h4>
                              <p className="text-xs text-muted-foreground mt-1">
                                Comprobante: {boleto.numero_comprobante || 'N/A'}
                              </p>
                            </div>
                            <div className="text-right">
                              <p className="text-sm font-black text-emerald-600">${boleto.precio_pagado}</p>
                              <CheckCircle className="w-4 h-4 text-emerald-500 ml-auto mt-1" />
                            </div>
                          </div>
                        </CardContent>
                      </Card>
                    ))}
                  </div>
                )}
              </TabsContent>
            </Tabs>
          )}
        </div>
      </DialogContent>
    </Dialog>

    </div>
  );
};

export default AdminDashboard;
